const teamKits = {
  "Aberdeen": {
      "name": "Aberdeen",
      "url": "img/teams/Aberdeen.svg"
  },
  "Aberdeen FC": {
      "name": "Aberdeen",
      "url": "img/teams/Aberdeen.svg"
  },//ndryshime
  "Aberystwyth": {
      "name": "Aberystwyth",
      "url": "img/teams/Aberystwyth.svg"
  },
  "Aberystwyth Town FC": {
      "name": "Aberystwyth",
      "url": "img/teams/Aberystwyth.svg"
  },//ndryshime
  "AC Ajaccio": {
      "name": "AC Ajaccio",
      "url": "img/teams/AC Ajaccio.svg"
  },
  "AC Milan": {
      "name": "AC Milan",
      "url": "img/teams/AC Milan.svg"
  },
  "AC Reggiana": {
      "name": "AC Reggiana",
      "url": "img/teams/AC Reggiana.svg"
  },
  "Reggiana 1919": {
      "name": "AC Reggiana",
      "url": "img/teams/AC Reggiana.svg"
  },//ndryshime
  "Accrington": {
      "name": "Accrington",
      "url": "img/teams/Accrington.svg"
  },
  "Accrington Stanley": {
      "name": "Accrington",
      "url": "img/teams/Accrington.svg"
  },//ndryshime
  "AFC Fylde": {
      "name": "AFC Fylde",
      "url": "img/teams/AFC Fylde.svg"
  },
  "AFC Wimbledon": {
      "name": "AFC Wimbledon",
      "url": "img/teams/AFC Wimbledon.svg"
  },
  "Airdrieonians": {
      "name": "Airdrieonians",
      "url": "img/teams/Airdrieonians.svg"
  },
  "Airdrieonians FC": {
      "name": "Airdrieonians",
      "url": "img/teams/Airdrieonians.svg"
  },//ndryshime
  "Albacete Balompie": {
      "name": "Albacete Balompie",
      "url": "img/teams/Albacete Balompie.svg"
  },
  "Aldershot": {
      "name": "Aldershot",
      "url": "img/teams/Aldershot.svg"
  },
  "Aldershot Town": {
      "name": "Aldershot",
      "url": "img/teams/Aldershot.svg"
  },//ndryshime
  "Alloa": {
      "name": "Alloa",
      "url": "img/teams/Alloa.svg"
  },
  "Alloa Athletic FC": {
      "name": "Alloa",
      "url": "img/teams/Alloa.svg"
  },//ndryshime
  "Almería": {
      "name": "Almería",
      "url": "img/teams/Almería.svg"
  },
  "UD Almería": {
      "name": "Almería",
      "url": "img/teams/Almería.svg"
  },//ndryshime
  "Altrincham": {
      "name": "Altrincham",
      "url": "img/teams/Altrincham.svg"
  },
  "Altrincham FC": {
      "name": "Altrincham",
      "url": "img/teams/Altrincham.svg"
  },//ndryshime
  "Amiens": {
      "name": "Amiens",
      "url": "img/teams/Amiens.svg"
  },
  "Amiens SC": {
      "name": "Amiens",
      "url": "img/teams/Amiens.svg"
  },//ndryshime
  "Anderlecht": {
      "name": "Anderlecht",
      "url": "img/teams/Anderlecht.svg"
  },
  "RSC Anderlecht": {
      "name": "Anderlecht",
      "url": "img/teams/Anderlecht.svg"
  },//ndryshime
  "Angers": {
      "name": "Angers",
      "url": "img/teams/Angers.svg"
  },
  "Angers SCO": {
      "name": "Angers",
      "url": "img/teams/Angers.svg"
  },//ndryshime
  "Annan Athletic": {
      "name": "Annan Athletic",
      "url": "img/teams/Annan Athletic.svg"
  },
  "Annan Athletic FC": {
      "name": "Annan Athletic",
      "url": "img/teams/Annan Athletic.svg"
  },//ndryshime
  "Annecy": {
      "name": "Annecy",
      "url": "img/teams/Annecy.svg"
  },
  "FC Annecy": {
      "name": "Annecy",
      "url": "img/teams/Annecy.svg"
  },//ndryshime
  "Antwerp": {
      "name": "Antwerp",
      "url": "img/teams/Antwerp.svg"
  },
  "Royal Antwerp FC": {
      "name": "Antwerp",
      "url": "img/teams/Antwerp.svg"
  },//ndryshime
  "Arbroath": {
      "name": "Arbroath",
      "url": "img/teams/Arbroath.svg"
  },
  "Arbroath FC": {
      "name": "Arbroath",
      "url": "img/teams/Arbroath.svg"
  },//ndryshime
  "Arsenal": {
      "name": "Arsenal",
      "url": "img/teams/Arsenal.svg"
  },
  "Arsenal FC": {
      "name": "Arsenal",
      "url": "img/teams/Arsenal.svg"
  }, //ndryshime
  "ASK Voitsberg": {
      "name": "ASK Voitsberg",
      "url": "img/teams/ASK Voitsberg.svg"
  },
  "Aston Villa ": {
      "name": "Aston Villa ",
      "url": "img/teams/Aston Villa.svg"
  },
  "Atalanta": {
      "name": "Atalanta",
      "url": "img/teams/Atalanta.svg"
  },
  "Atalanta BC": {
      "name": "Atalanta",
      "url": "img/teams/Atalanta.svg"
  },//ndryshime
  "Athletico Bilbao": {
      "name": "Athletico Bilbao",
      "url": "img/teams/Athletico Bilbao.svg"
  },
  "Athletic Bilbao": {
      "name": "Athletico Bilbao",
      "url": "img/teams/Athletico Bilbao.svg"
  },//ndryshime
  "Atletico Madrid": {
      "name": "Atletico Madrid",
      "url": "img/teams/Atletico Madrid.svg"
  },
  "Augsburg ": {
      "name": "Augsburg ",
      "url": "img/teams/Augsburg.svg"
  },
  "FC Augsburg ": {
      "name": "Augsburg ",
      "url": "img/teams/Augsburg.svg"
  }, //ndryshime
  "Austria Klagenfurt": {
      "name": "Austria Klagenfurt",
      "url": "img/teams/Austria Klagenfurt.svg"
  },
  "SK Austria Klagenfurt": {
      "name": "Austria Klagenfurt",
      "url": "img/teams/Austria Klagenfurt.svg"
  },//ndryshime
  "Austria Lustenau": {
      "name": "Austria Lustenau",
      "url": "img/teams/Austria Lustenau.svg"
  },
  "Auxerre": {
      "name": "Auxerre",
      "url": "img/teams/Auxerre.svg"
  },
  "AJ Auxerre": {
      "name": "Auxerre",
      "url": "img/teams/Auxerre.svg"
  },//ndryshime
  "AVS": {
      "name": "AVS",
      "url": "img/teams/AVS.svg"
  },
  "AVS Futebol SAD": {
      "name": "AVS",
      "url": "img/teams/AVS.svg"
  },//ndryshime
  "Ayr": {
      "name": "Ayr",
      "url": "img/teams/Ayr.svg"
  },
  "Ayr United FC": {
      "name": "Ayr",
      "url": "img/teams/Ayr.svg"
  },//ndryshime
  "Bala Town": {
      "name": "Bala Town",
      "url": "img/teams/Bala Town.svg"
  },
  "Bala Town FC": {
      "name": "Bala Town",
      "url": "img/teams/Bala Town.svg"
  },//ndryshime
  "Barcelona": {
      "name": "Barcelona",
      "url": "img/teams/Barcelona.svg"
  },
  "FC Barcelona": {
      "name": "Barcelona",
      "url": "img/teams/Barcelona.svg"
  }, //ndryshime
  "Bari": {
      "name": "Bari",
      "url": "img/teams/Bari.svg"
  },
  "SSC Bari": {
      "name": "Bari",
      "url": "img/teams/Bari.svg"
  },//ndryshime
  "Barnet": {
      "name": "Barnet",
      "url": "img/teams/Barnet.svg"
  },
  "Barnet FC": {
      "name": "Barnet",
      "url": "img/teams/Barnet.svg"
  },//ndryshime
  "Barnsley": {
      "name": "Barnsley",
      "url": "img/teams/Barnsley.svg"
  },
  "Barnsley FC": {
      "name": "Barnsley",
      "url": "img/teams/Barnsley.svg"
  },//ndryshime
  "Barrow": {
      "name": "Barrow",
      "url": "img/teams/Barrow.svg"
  },
  "Barrow AFC": {
      "name": "Barrow",
      "url": "img/teams/Barrow.svg"
  },//ndryshime
  "Barry Town": {
      "name": "Barry Town",
      "url": "img/teams/Barry Town.svg"
  },
  "Barry Town United FC": {
      "name": "Barry Town",
      "url": "img/teams/Barry Town.svg"
  },//ndryshime
  "Bayer Leverkusen": {
      "name": "Bayer Leverkusen",
      "url": "img/teams/Bayer Leverkusen.svg"
  },
  "Bayern Munich": {
      "name": "Bayern Munich",
      "url": "img/teams/Bayern Munich.svg"
  },
  "Benfica": {
      "name": "Benfica",
      "url": "img/teams/Benfica.svg"
  },
  "SL Benfica": {
      "name": "Benfica",
      "url": "img/teams/Benfica.svg"
  },//ndryshime
  "Birmingham": {
      "name": "Birmingham",
      "url": "img/teams/Birmingham.svg"
  },
  "Birmingham City": {
      "name": "Birmingham",
      "url": "img/teams/Birmingham.svg"
  },//ndryshime
  "Blackburn Rovers": {
      "name": "Blackburn Rovers",
      "url": "img/teams/Blackburn Rovers.svg"
  },
  "Blackpool": {
      "name": "Blackpool",
      "url": "img/teams/Blackpool.svg"
  },
  "Blackpool FC": {
      "name": "Blackpool",
      "url": "img/teams/Blackpool.svg"
  },//ndryshime
  "Boavista": {
      "name": "Boavista",
      "url": "img/teams/Boavista.svg"
  },
  "Boavista Porto": {
      "name": "Boavista",
      "url": "img/teams/Boavista.svg"
  },//ndryshime
  "Bologna": {
      "name": "Bologna",
      "url": "img/teams/Bologna.svg"
  },
  "Bologna FC": {
      "name": "Bologna",
      "url": "img/teams/Bologna.svg"
  },//ndryshime
  "Bolton": {
      "name": "Bolton",
      "url": "img/teams/Bolton.svg"
  },
  "Bolton Wanderers": {
      "name": "Bolton",
      "url": "img/teams/Bolton.svg"
  },//ndryshime
  "Bonnyrigg Rose": {
      "name": "Bonnyrigg Rose",
      "url": "img/teams/Bonnyrigg Rose.svg"
  },
  "Borussia Dortmund": {
      "name": "Borussia Dortmund",
      "url": "img/teams/Borussia Dortmund.svg"
  },
  "Borussia Mgladbach": {
      "name": "Borussia Mgladbach",
      "url": "img/teams/Borussia M'gladbach.svg"
  },
  "Borussia Monchengladbach": {
      "name": "Borussia Mgladbach",
      "url": "img/teams/Borussia M'gladbach.svg"
  },//ndryshime
  "Boston Utd": {
      "name": "Boston Utd",
      "url": "img/teams/Boston Utd.svg"
  },
  "Boston United FC": {
      "name": "Boston Utd",
      "url": "img/teams/Boston Utd.svg"
  },//ndryshime
  "Bournemouth": {
      "name": "Bournemouth",
      "url": "img/teams/Bournemouth.svg"
  },
  "AFC Bournemouth": {
      "name": "Bournemouth",
      "url": "img/teams/Bournemouth.svg"
  },//ndryshime
  "Bradford": {
      "name": "Bradford",
      "url": "img/teams/Bradford.svg"
  },
  "Bradford City FC": {
      "name": "Bradford",
      "url": "img/teams/Bradford.svg"
  },//ndryshime
  "Braga": {
      "name": "Braga",
      "url": "img/teams/Braga.svg"
  },
  "SC Braga": {
      "name": "Braga",
      "url": "img/teams/Braga.svg"
  },//ndryshime
  "Braintree Town": {
      "name": "Braintree Town",
      "url": "img/teams/Braintree Town.svg"
  },
  "Braintree Town FC": {
      "name": "Braintree Town",
      "url": "img/teams/Braintree Town.svg"
  },//ndryshime
  "Brentford": {
      "name": "Brentford",
      "url": "img/teams/Brentford.svg"
  },
  "Brentford FC": {
      "name": "Brentford",
      "url": "img/teams/Brentford.svg"
  },//ndryshime
  "Brescia": {
      "name": "Brescia",
      "url": "img/teams/Brescia.svg"
  },
  "Brescia Calcio": {
      "name": "Brescia",
      "url": "img/teams/Brescia.svg"
  },//ndryshime
  "Brest": {
      "name": "Brest",
      "url": "img/teams/Brest.svg"
  },
  "Brighton": {
      "name": "Brighton",
      "url": "img/teams/Brighton.svg"
  },
  "Brighton Hove Albion": {
      "name": "Brighton",
      "url": "img/teams/Brighton.svg"
  },//ndryshime
  "Bristol City": {
      "name": "Bristol City",
      "url": "img/teams/Bristol City.svg"
  },
  "Bristol Rovers": {
      "name": "Bristol Rovers",
      "url": "img/teams/Bristol Rovers.svg"
  },
  "Briton Ferry": {
      "name": "Briton Ferry",
      "url": "img/teams/Briton Ferry.svg"
  },
  "Bromley": {
      "name": "Bromley",
      "url": "img/teams/Bromley.svg"
  },
  "Bromley FC": {
      "name": "Bromley",
      "url": "img/teams/Bromley.svg"
  },//ndryshime
  "Burgos": {
      "name": "Burgos",
      "url": "img/teams/Burgos.svg"
  },
  "Burgos CF": {
      "name": "Burgos",
      "url": "img/teams/Burgos.svg"
  },//ndryshime
  "Burnley": {
      "name": "Burnley",
      "url": "img/teams/Burnley.svg"
  },
  "Burnley FC": {
      "name": "Burnley",
      "url": "img/teams/Burnley.svg"
  },//ndryshime
  "Burton Albion ": {
      "name": "Burton Albion",
      "url": "img/teams/Burton Albion.svg"
  },
  "Cadiz": {
      "name": "Cadiz",
      "url": "img/teams/Cadiz.svg"
  },
  "Cadiz FC": {
      "name": "Cadiz",
      "url": "img/teams/Cadiz.svg"
  },//ndryshime
  "Caen": {
      "name": "Caen",
      "url": "img/teams/Caen.svg"
  },
  "SM Caen": {
      "name": "Caen",
      "url": "img/teams/Caen.svg"
  },//ndryshime
  "Caernarfon": {
      "name": "Caernarfon",
      "url": "img/teams/Caernarfon.svg"
  },
  "Caernarfon Town FC": {
      "name": "Caernarfon",
      "url": "img/teams/Caernarfon.svg"
  },//ndryshim
  "Cagliari": {
      "name": "Cagliari",
      "url": "img/teams/Cagliari.svg"
  },
  "Cagliari Calcio": {
      "name": "Cagliari",
      "url": "img/teams/Cagliari.svg"
  },//ndryshime
  "Cambridge   new": {
      "name": "Cambridge   new",
      "url": "img/teams/Cambridge.svg"
  },
  "Cambridge United": {
      "name": "Cambridge   new",
      "url": "img/teams/Cambridge.svg"
  },
  "Cardiff": {
      "name": "Cardiff",
      "url": "img/teams/Cardiff.svg"
  },
  "Cardiff City": {
      "name": "Cardiff",
      "url": "img/teams/Cardiff.svg"
  },//ndryshime
  "Cardiff Met Uni": {
      "name": "Cardiff Met Uni",
      "url": "img/teams/Cardiff Met Uni.svg"
  },
  "Carlisle": {
      "name": "Carlisle",
      "url": "img/teams/Carlisle.svg"
  },
  "Carlisle United": {
      "name": "Carlisle",
      "url": "img/teams/Carlisle.svg"
  },//ndryshime
  "Carrarese": {
      "name": "Carrarese",
      "url": "img/teams/Carrarese.svg"
  },
  "Carrarese Calcio": {
      "name": "Carrarese",
      "url": "img/teams/Carrarese.svg"
  },//ndryshime
  "Casa Pia": {
      "name": "Casa Pia",
      "url": "img/teams/Casa Pia.svg"
  },
  "Casa Pia Lisbon": {
      "name": "Casa Pia",
      "url": "img/teams/Casa Pia.svg"
  },//ndryshime
  "Castellon": {
      "name": "Castellon",
      "url": "img/teams/Castellon.svg"
  },
  "CD Castellon": {
      "name": "Castellon",
      "url": "img/teams/Castellon.svg"
  },//ndryshime
  "Catanzaro": {
      "name": "Catanzaro",
      "url": "img/teams/Catanzaro.svg"
  },
  "US Catanzaro": {
      "name": "Catanzaro",
      "url": "img/teams/Catanzaro.svg"
  },//ndryshime
  "CD Alaves": {
      "name": "CD Alaves",
      "url": "img/teams/CD Alaves.svg"
  },
  "Deportivo Alaves": {
      "name": "CD Alaves",
      "url": "img/teams/CD Alaves.svg"
  },//ndryshime
  "Celta Vigo": {
      "name": "Celta Vigo",
      "url": "img/teams/Celta Vigo.svg"
  },
  "RC Celta de Vigo": {
      "name": "Celta Vigo",
      "url": "img/teams/Celta Vigo.svg"
  },//ndryshime
  "Celtic": {
      "name": "Celtic",
      "url": "img/teams/Celtic.svg"
  },
  "Cercle Brugge": {
      "name": "Cercle Brugge",
      "url": "img/teams/Cercle Brugge.svg"
  },
  "Cesena": {
      "name": "Cesena",
      "url": "img/teams/Cesena.svg"
  },
  "Cesena FC": {
      "name": "Cesena",
      "url": "img/teams/Cesena.svg"
  },//ndryshime
  "Charleroi": {
      "name": "Charleroi",
      "url": "img/teams/Charleroi.svg"
  },
  "Royal Charleroi SC": {
      "name": "Charleroi",
      "url": "img/teams/Charleroi.svg"
  },//ndryshime
  "Charlton": {
      "name": "Charlton",
      "url": "img/teams/Charlton.svg"
  },
  "Charlton Athletic": {
      "name": "Charlton",
      "url": "img/teams/Charlton.svg"
  },//ndryshime
  "Chelsea": {
      "name": "Chelsea",
      "url": "img/teams/Chelsea.svg"
  },
  "Chelsea FC": {
      "name": "Chelsea",
      "url": "img/teams/Chelsea.svg"
  },//ndryshime
  "Cheltenham": {
      "name": "Cheltenham",
      "url": "img/teams/Cheltenham.svg"
  },
  "Cheltenham Town": {
      "name": "Cheltenham",
      "url": "img/teams/Cheltenham.svg"
  },//ndryshime
  "Chesterfield": {
      "name": "Chesterfield",
      "url": "img/teams/Chesterfield.svg"
  },
  "Chesterfield FC": {
      "name": "Chesterfield",
      "url": "img/teams/Chesterfield.svg"
  },//ndryshime
  "Cittadella": {
      "name": "Cittadella",
      "url": "img/teams/Cittadella.svg"
  },
  "AS Cittadella": {
      "name": "Cittadella",
      "url": "img/teams/Cittadella.svg"
  },//ndryshime
  "Clermont Foot": {
      "name": "Clermont Foot",
      "url": "img/teams/Clermont Foot.svg"
  },
  "Clermont Foot 63": {
      "name": "Clermont Foot",
      "url": "img/teams/Clermont Foot.svg"
  },//ndryshime
  "Club Brugge": {
      "name": "Club Brugge",
      "url": "img/teams/Club Brugge.svg"
  },
  "Clyde": {
      "name": "Clyde",
      "url": "img/teams/Clyde.svg"
  },
  "Clyde Fc": {
      "name": "Clyde",
      "url": "img/teams/Clyde.svg"
  },//ndryshime
  "Colchester": {
      "name": "Colchester",
      "url": "img/teams/Colchester.svg"
  },
  "Colchester United": {
      "name": "Colchester",
      "url": "img/teams/Colchester.svg"
  },//ndryshime
  "Cologne": {
      "name": "Cologne",
      "url": "img/teams/Cologne.svg"
  },
  "Cologne Fc": {
      "name": "Cologne",
      "url": "img/teams/Cologne.svg"
  },//ndryshime
  "Como": {
      "name": "Como",
      "url": "img/teams/Como.svg"
  },
  "Como 1907": {
      "name": "Como 1907",
      "url": "img/teams/Como.svg"
  },//ndryshime
  "Connahs Quay": {
      "name": "Connahs Quay",
      "url": "img/teams/Connah's Quay.svg"
  },
  "Cosenza": {
      "name": "Cosenza",
      "url": "img/teams/Cosenza.svg"
  },
  "Cosenza Calcio": {
      "name": "Cosenza",
      "url": "img/teams/Cosenza.svg"
  },//ndryshime
  "Cove Rangers": {
      "name": "Cove Rangers",
      "url": "img/teams/Cove Rangers.svg"
  },
  "Cove Rangers Fc": {
      "name": "Cove Rangers",
      "url": "img/teams/Cove Rangers.svg"
  },//ndryshime
  "Coventry City": {
      "name": "Coventry City",
      "url": "img/teams/Coventry City.svg"
  },
  "Crawley": {
      "name": "Crawley",
      "url": "img/teams/Crawley.svg"
  },
  "Crawley Town": {
      "name": "Crawley",
      "url": "img/teams/Crawley.svg"
  },//ndryshime
  "Cremonese": {
      "name": "Cremonese",
      "url": "img/teams/Cremonese.svg"
  },
  "US Cremonese": {
      "name": "Cremonese",
      "url": "img/teams/Cremonese.svg"
  },//ndryshime
  "Crewe": {
      "name": "Crewe",
      "url": "img/teams/Crewe.svg"
  },
  "Crewe Alexandra": {
      "name": "Crewe",
      "url": "img/teams/Crewe.svg"
  },//ndryshime
  "Crystal Palace": {
      "name": "Crystal Palace",
      "url": "img/teams/Crystal Palace.svg"
  },
  "Córdoba": {
      "name": "Córdoba",
      "url": "img/teams/Córdoba.svg"
  },
  "Dag and Red": {
      "name": "Dag and Red",
      "url": "img/teams/Dag and Red.svg"
  },
  "Dagenham and Redbridge FC": {
      "name": "Dag and Red",
      "url": "img/teams/Dag and Red.svg"
  },//ndryshime
  "Darmstadt": {
      "name": "Darmstadt",
      "url": "img/teams/Darmstadt.svg"
  },
  "SV Darmstadt 98": {
      "name": "Darmstadt",
      "url": "img/teams/Darmstadt.svg"
  },//ndryshime
  "Dender": {
      "name": "Dender",
      "url": "img/teams/Dender.svg"
  },
  "FC Dender EH": {
      "name": "Dender",
      "url": "img/teams/Dender.svg"
  },//ndryshime
  "Deportivo": {
      "name": "Deportivo",
      "url": "img/teams/Deportivo.svg"
  },
  "Derby": {
      "name": "Derby",
      "url": "img/teams/Derby.svg"
  },
  "Derby County": {
      "name": "Derby",
      "url": "img/teams/Derby.svg"
  },//ndryshime
  "Doncaster": {
      "name": "Doncaster",
      "url": "img/teams/Doncaster.svg"
  },
  "Dumbarton": {
      "name": "Dumbarton",
      "url": "img/teams/Dumbarton.svg"
  },
  "Dumbarton FC": {
      "name": "Dumbarton",
      "url": "img/teams/Dumbarton.svg"
  },//ndryshim
  "Dundee -": {
      "name": "Dundee -",
      "url": "img/teams/Dundee.svg"
  },
  "Dundee FC": {
      "name": "Dundee -",
      "url": "img/teams/Dundee.svg"
  },//ndryshime
  "Dundee Utd  Kit 2324": {
      "name": "Dundee Utd  Kit 2324",
      "url": "img/teams/Dundee Utd.svg"
  },
  "Dundee United": {
      "name": "Dundee Utd  Kit 2324",
      "url": "img/teams/Dundee Utd.svg"
  },//ndryshime
  "Dunfermline": {
      "name": "Dunfermline",
      "url": "img/teams/Dunfermline.svg"
  },
  "Dunfermline Athletic FC": {
      "name": "Dunfermline",
      "url": "img/teams/Dunfermline.svg"
  },//ndryshime
  "Dunkerque": {
      "name": "Dunkerque",
      "url": "img/teams/Dunkerque.svg"
  },
  "USL Dunkerque": {
      "name": "Dunkerque",
      "url": "img/teams/Dunkerque.svg"
  }, //ndryshime
  "East Fife": {
      "name": "East Fife",
      "url": "img/teams/East Fife.svg"
  },
  "East Fife FC": {
      "name": "East Fife",
      "url": "img/teams/East Fife.svg"
  },//ndryshime
  "Eastleigh": {
      "name": "Eastleigh",
      "url": "img/teams/Eastleigh.svg"
  },
  "Eastleigh FC": {
      "name": "Eastleigh",
      "url": "img/teams/Eastleigh.svg"
  },//ndryshime
  "Ebbsfleet United": {
      "name": "Ebbsfleet United",
      "url": "img/teams/Ebbsfleet United.svg"
  },
  "Ebbsfleet United FC": {
      "name": "Ebbsfleet United",
      "url": "img/teams/Ebbsfleet United.svg"
  },//ndryshime
  "Edinburgh City": {
      "name": "Edinburgh City",
      "url": "img/teams/Edinburgh City.svg"
  },
  "Edinburgh City FC": {
      "name": "Edinburgh City",
      "url": "img/teams/Edinburgh City.svg"
  },//ndryshime
  "Eibar": {
      "name": "Eibar",
      "url": "img/teams/Eibar.svg"
  },
  "SD Eibar": {
      "name": "Eibar",
      "url": "img/teams/Eibar.svg"
  },//ndryshime
  "Eintracht Braunschweig": {
      "name": "Eintracht Braunschweig",
      "url": "img/teams/Eintracht Braunschweig.svg"
  },
  "Eintracht Frankfurt": {
      "name": "Eintracht Frankfurt",
      "url": "img/teams/Eintracht Frankfurt.svg"
  },
  "Elche": {
      "name": "Elche",
      "url": "img/teams/Elche.svg"
  },
  "Elche FC": {
      "name": "Elche",
      "url": "img/teams/Elche.svg"
  },//ndryshime
  "Eldense": {
      "name": "Eldense",
      "url": "img/teams/Eldense.svg"
  },
  "Club Deportivo Eldense": {
      "name": "Eldense",
      "url": "img/teams/Eldense.svg"
  },//ndryshime
  "Elgin": {
      "name": "Elgin",
      "url": "img/teams/Elgin.svg"
  },
  "Elgin City FC": {
      "name": "Elgin",
      "url": "img/teams/Elgin.svg"
  },//ndryshime
  "Elversberg": {
      "name": "Elversberg",
      "url": "img/teams/Elversberg.svg"
  },
  "SV 07 Elversberg": {
      "name": "Elversberg",
      "url": "img/teams/Elversberg.svg"
  },//ndryshime
  "Empoli": {
      "name": "Empoli",
      "url": "img/teams/Empoli.svg"
  },
  "Empoli FC": {
      "name": "Empoli",
      "url": "img/teams/Empoli.svg"
  },//ndryshime
  "Espanyol": {
      "name": "Espanyol",
      "url": "img/teams/Espanyol.svg"
  },
  "Espanyol Barcelona": {
      "name": "Espanyol",
      "url": "img/teams/Espanyol.svg"
  },//ndryshime
  "Estoril": {
      "name": "Estoril",
      "url": "img/teams/Estoril.svg"
  },
  "Estoril Praya": {
      "name": "Estoril",
      "url": "img/teams/Estoril.svg"
  },//ndryshime
  "Estrela Amadora": {
      "name": "Estrela Amadora",
      "url": "img/teams/Estrela Amadora.svg"
  },
  "Everton": {
      "name": "Everton",
      "url": "img/teams/Everton.svg"
  },
  "Everton FC": {
      "name": "Everton",
      "url": "img/teams/Everton.svg"
  },//ndryshime
  "Exeter City": {
      "name": "Exeter City",
      "url": "img/teams/Exeter City.svg"
  },
  "Falkirk": {
      "name": "Falkirk",
      "url": "img/teams/Falkirk.svg"
  },
  "Falkirk FC": {
      "name": "Falkirk",
      "url": "img/teams/Falkirk.svg"
  },//ndryshime
  "Famalicao": {
      "name": "Famalicao",
      "url": "img/teams/Famalicao.svg"
  },
  "FC Famalicao": {
      "name": "Famalicao",
      "url": "img/teams/Famalicao.svg"
  },//ndryshime
  "FC Arouca": {
      "name": "FC Arouca",
      "url": "img/teams/FC Arouca.svg"
  },
  "FC Blau Weiss Linz": {
      "name": "FC Blau Weiss Linz",
      "url": "img/teams/FC Blau Weiss Linz.svg"
  },
  "Blau-Weiss Linz": {
      "name": "FC Blau Weiss Linz",
      "url": "img/teams/FC Blau Weiss Linz.svg"
  },//ndryshime
  "FC Cartagena": {
      "name": "FC Cartagena",
      "url": "img/teams/FC Cartagena.svg"
  },
  "FC Flyeralarm Admira": {
      "name": "FC Flyeralarm Admira",
      "url": "img/teams/FC Flyeralarm Admira.svg"
  },
  "FC Liefering": {
      "name": "FC Liefering",
      "url": "img/teams/FC Liefering.svg"
  },
  "FC Porto": {
      "name": "FC Porto",
      "url": "img/teams/FC Porto.svg"
  },
  "FC Salzburg": {
      "name": "FC Salzburg",
      "url": "img/teams/FC Salzburg.svg"
  },
  "Fiorentina": {
      "name": "Fiorentina",
      "url": "img/teams/Fiorentina.svg"
  },
  "ACF Fiorentina": {
      "name": "Fiorentina",
      "url": "img/teams/Fiorentina.svg"
  },//ndryshime
  "First Vienna FC 1894": {
      "name": "First Vienna FC 1894",
      "url": "img/teams/First Vienna FC 1894.svg"
  },
  "FK Austria Vienna": {
      "name": "FK Austria Vienna",
      "url": "img/teams/FK Austria Vienna.svg"
  },
  "FK Austria Wien": {
      "name": "FK Austria Vienna",
      "url": "img/teams/FK Austria Vienna.svg"
  },//ndryshime
  "fleetwod town": {
      "name": "fleetwod town",
      "url": "img/teams/fleetwod town.svg"
  },
  "Flint Town Utd": {
      "name": "Flint Town Utd",
      "url": "img/teams/Flint Town Utd.svg"
  },
  "Floridsdorfer AC": {
      "name": "Floridsdorfer AC",
      "url": "img/teams/Floridsdorfer AC.svg"
  },
  "Forest Green Rovers  23-24": {
      "name": "Forest Green Rovers",
      "url": "img/teams/Forest Green Rovers.svg"
  },
  "Forest Green Rovers": {
      "name": "Forest Green Rovers",
      "url": "img/teams/Forest Green Rovers.svg"
  },//ndryshime
  "Forfar": {
      "name": "Forfar",
      "url": "img/teams/Forfar.svg"
  },
  "Forfar Athletic FC": {
      "name": "Forfar",
      "url": "img/teams/Forfar.svg"
  },//ndryshime
  "Fortuna Dusseldorf": {
      "name": "Fortuna Dusseldorf",
      "url": "img/teams/Fortuna Dusseldorf.svg"
  },
  "Frosinone": {
      "name": "Frosinone",
      "url": "img/teams/Frosinone.svg"
  },
  "Frosinone Calcio": {
      "name": "Frosinone",
      "url": "img/teams/Frosinone.svg"
  },//ndryshime
  "Fulham": {
      "name": "Fulham",
      "url": "img/teams/Fulham.svg"
  },
  "Fulham FC": {
      "name": "Fulham",
      "url": "img/teams/Fulham.svg"
  },//ndryshime
  "Gateshead": {
      "name": "Gateshead",
      "url": "img/teams/Gateshead.svg"
  },
  "Gateshead FC": {
      "name": "Gateshead",
      "url": "img/teams/Gateshead.svg"
  },//ndryshime
  "Genk": {
      "name": "Genk",
      "url": "img/teams/Genk.svg"
  },
  "KRC Genk": {
      "name": "Genk",
      "url": "img/teams/Genk.svg"
  },//ndryshime
  "Genoa": {
      "name": "Genoa",
      "url": "img/teams/Genoa.svg"
  },
  "Genoa CFC": {
      "name": "Genoa",
      "url": "img/teams/Genoa.svg"
  },//ndryshime
  "Gent": {
      "name": "Gent",
      "url": "img/teams/Gent.svg"
  },
  "Getafe": {
      "name": "Getafe",
      "url": "img/teams/Getafe.svg"
  },
  "Getafe CF": {
      "name": "Getafe",
      "url": "img/teams/Getafe.svg"
  },//ndryshime
  "Gil Vicente": {
      "name": "Gil Vicente",
      "url": "img/teams/Gil Vicente.svg"
  },
  "Gil Vicente Barcelos": {
      "name": "Gil Vicente",
      "url": "img/teams/Gil Vicente.svg"
  },//ndryshime
  "Gillingham": {
      "name": "Gillingham",
      "url": "img/teams/Gillingham.svg"
  },
  "Gillingham FC": {
      "name": "Gillingham",
      "url": "img/teams/Gillingham.svg"
  },//ndryshime
  "Girona": {
      "name": "Girona",
      "url": "img/teams/Girona.svg"
  },
  "Granada": {
      "name": "Granada",
      "url": "img/teams/Granada.svg"
  },
  "Granada CF": {
      "name": "Granada",
      "url": "img/teams/Granada.svg"
  },//ndryshime
  "Grazer AK": {
      "name": "Grazer AK",
      "url": "img/teams/Grazer AK.svg"
  },
  "Grazer AK 1902": {
      "name": "Grazer AK",
      "url": "img/teams/Grazer AK.svg"
  },//ndryshime
  "Grenoble": {
      "name": "Grenoble",
      "url": "img/teams/Grenoble.svg"
  },
  "Grenoble Foot": {
      "name": "Grenoble",
      "url": "img/teams/Grenoble.svg"
  },//ndryshime
  "Greuther Furth": {
      "name": "Greuther Furth",
      "url": "img/teams/Greuther Furth.svg"
  },
  "Grimsby Town": {
      "name": "Grimsby Town",
      "url": "img/teams/Grimsby Town.svg"
  },
  "Guimaraes": {
      "name": "Guimaraes",
      "url": "img/teams/Guimaraes.svg"
  },
  "SC Guimaraes": {
      "name": "Guimaraes",
      "url": "img/teams/Guimaraes.svg"
  },//ndryshime
  "Guingamp": {
      "name": "Guingamp",
      "url": "img/teams/Guingamp.svg"
  },
  "EA Guingamp": {
      "name": "Guingamp",
      "url": "img/teams/Guingamp.svg"
  },
  "Halifax": {
      "name": "Halifax",
      "url": "img/teams/Halifax.svg"
  },
  "FC Halifax": {
      "name": "Halifax",
      "url": "img/teams/Halifax.svg"
  },//ndryshime
  "Hamburg": {
      "name": "Hamburg",
      "url": "img/teams/Hamburg.svg"
  },
  "Hamburg SV": {
      "name": "Hamburg",
      "url": "img/teams/Hamburg.svg"
  },//ndryshime
  "Hamilton": {
      "name": "Hamilton",
      "url": "img/teams/Hamilton.svg"
  },
  "Hamilton Academical FC": {
      "name": "Hamilton",
      "url": "img/teams/Hamilton.svg"
  },//ndryshime
  "Hannover 96": {
      "name": "Hannover 96",
      "url": "img/teams/Hannover 96.svg"
  },
  "Harrogate Town": {
      "name": "Harrogate Town",
      "url": "img/teams/Harrogate Town.svg"
  },
  "Hartberg": {
      "name": "Hartberg",
      "url": "img/teams/Hartberg.svg"
  },
  "TSV Hartberg": {
      "name": "Hartberg",
      "url": "img/teams/Hartberg.svg"
  },//ndryshime
  "Hartlepool": {
      "name": "Hartlepool",
      "url": "img/teams/Hartlepool.svg"
  },
  "Hartlepool United": {
      "name": "Hartlepool",
      "url": "img/teams/Hartlepool.svg"
  },//ndryshime
  "Haverfordwest": {
      "name": "Haverfordwest",
      "url": "img/teams/Haverfordwest.svg"
  },
  "Haverfordwest County AFC": {
      "name": "Haverfordwest",
      "url": "img/teams/Haverfordwest.svg"
  },//ndryshime
  "Hearts": {
      "name": "Hearts",
      "url": "img/teams/Hearts.svg"
  },
  "Kelty Hearts FC": {
      "name": "Hearts",
      "url": "img/teams/Hearts.svg"
  },//ndryshime
  "Heidenheim": {
      "name": "Heidenheim",
      "url": "img/teams/Heidenheim.svg"
  },
  "FC Heidenheim": {
      "name": "Heidenheim",
      "url": "img/teams/Heidenheim.svg"
  },//ndryshime
  "Hertha Berlin": {
      "name": "Hertha Berlin",
      "url": "img/teams/Hertha Berlin.svg"
  },
  "Hertha BSC": {
      "name": "Hertha Berlin",
      "url": "img/teams/Hertha Berlin.svg"
  },//ndryshim
  "Hibs": {
      "name": "Hibs",
      "url": "img/teams/Hibs.svg"
  },
  "Holstein Kiel": {
      "name": "Holstein Kiel",
      "url": "img/teams/Holstein Kiel.svg"
  },
  "Huddersfield": {
      "name": "Huddersfield",
      "url": "img/teams/Huddersfield.svg"
  },
  "Huddersfield Town": {
      "name": "Huddersfield",
      "url": "img/teams/Huddersfield.svg"
  },//ndryshime
  "Huesca": {
      "name": "Huesca",
      "url": "img/teams/Huesca.svg"
  },
  "SD Huesca": {
      "name": "Huesca",
      "url": "img/teams/Huesca.svg"
  },//ndryshime
  "Hull": {
      "name": "Hull",
      "url": "img/teams/Hull.svg"
  },
  "Hull City": {
      "name": "Hull",
      "url": "img/teams/Hull.svg"
  },//ndryshime
  "Inter Milan": {
      "name": "Inter Milan",
      "url": "img/teams/Inter Milan.svg"
  },
  "Inter Milano": {
      "name": "Inter Milan",
      "url": "img/teams/Inter Milan.svg"
  },//ndryshime
  "Inverness CT": {
      "name": "Inverness CT",
      "url": "img/teams/Inverness CT.svg"
  },
  "Inverness Caledonian Thistle FC": {
      "name": "Inverness CT",
      "url": "img/teams/Inverness CT.svg"
  },//ndryshim
  "Ipswich": {
      "name": "Ipswich",
      "url": "img/teams/Ipswich.svg"
  },
  "Ipswich Town": {
      "name": "Ipswich",
      "url": "img/teams/Ipswich.svg"
  },//ndryshime
  "Jahn Regensburg": {
      "name": "Jahn Regensburg",
      "url": "img/teams/Jahn Regensburg.svg"
  },
  "Juve Stabia": {
      "name": "Juve Stabia",
      "url": "img/teams/Juve Stabia.svg"
  },
  "Juventus": {
      "name": "Juventus",
      "url": "img/teams/Juventus.svg"
  },
  "Kaiserslautern": {
      "name": "Kaiserslautern",
      "url": "img/teams/Kaiserslautern.svg"
  },
  "FC Kaiserslautern": {
      "name": "Kaiserslautern",
      "url": "img/teams/Kaiserslautern.svg"
  },//ndryshim
  "Karlsruher SC": {
      "name": "Karlsruher SC",
      "url": "img/teams/Karlsruher SC.svg"
  },
  "Kelty Hearts": {
      "name": "Kelty Hearts",
      "url": "img/teams/Kelty Hearts.svg"
  },
  "Kelty Hearts FC": {
      "name": "Kelty Hearts",
      "url": "img/teams/Kelty Hearts.svg"
  },//ndryshime
  "KFCO Beerschot Wilrijk": {
      "name": "KFCO Beerschot Wilrijk",
      "url": "img/teams/KFCO Beerschot Wilrijk.svg"
  },
  "K Beerschot VA": {
      "name": "KFCO Beerschot Wilrijk",
      "url": "img/teams/KFCO Beerschot Wilrijk.svg"
  },//ndryshime
  "Kilmarnock": {
      "name": "Kilmarnock",
      "url": "img/teams/Kilmarnock.svg"
  },
  "Kilmarnock FC": {
      "name": "Kilmarnock",
      "url": "img/teams/Kilmarnock.svg"
  },//ndryshime
  "KV Kortrijk": {
      "name": "KV Kortrijk",
      "url": "img/teams/KV Kortrijk.svg"
  },
  "KV Mechelen": {
      "name": "KV Mechelen",
      "url": "img/teams/KV Mechelen.svg"
  },
  "Yellow-Red KV Mechelen": {
      "name": "KV Mechelen",
      "url": "img/teams/KV Mechelen.svg"
  },//ndryshime
  "Las Palmas": {
      "name": "Las Palmas",
      "url": "img/teams/Las Palmas.svg"
  },
  "UD Las Palmas": {
      "name": "Las Palmas",
      "url": "img/teams/Las Palmas.svg"
  },//ndryshime
  "LASK Linz": {
      "name": "LASK Linz",
      "url": "img/teams/LASK Linz.svg"
  },
  "Laval": {
      "name": "Laval",
      "url": "img/teams/Laval.svg"
  },
  "Lazio": {
      "name": "Lazio",
      "url": "img/teams/Lazio.svg"
  },
  "SS Lazio": {
      "name": "Lazio",
      "url": "img/teams/Lazio.svg"
  },//ndryshime
  "Le Havre": {
      "name": "Le Havre",
      "url": "img/teams/Le Havre.svg"
  },
  "Le Havre AC": {
      "name": "Le Havre",
      "url": "img/teams/Le Havre.svg"
  },//ndryshime
  "Lecce": {
      "name": "Lecce",
      "url": "img/teams/Lecce.svg"
  },
  "US Lecce": {
      "name": "Lecce",
      "url": "img/teams/Lecce.svg"
  },//ndryshime
  "Leeds": {
      "name": "Leeds",
      "url": "img/teams/Leeds.svg"
  },
  "Leeds United": {
      "name": "Leeds",
      "url": "img/teams/Leeds.svg"
  },//ndryshime
  "Leganes": {
      "name": "Leganes",
      "url": "img/teams/Leganes.svg"
  },
  "CD Leganes": {
      "name": "Leganes",
      "url": "img/teams/Leganes.svg"
  },//ndryshime
  "Leicester": {
      "name": "Leicester  Kit 20",
      "url": "img/teams/Leicester.svg"
  },
  "Leicester City": {
      "name": "Leicester  Kit 20",
      "url": "img/teams/Leicester.svg"
  },//ndryshime
  "Lens": {
      "name": "Lens",
      "url": "img/teams/Lens.svg"
  },
  "RC Lens": {
      "name": "Lens",
      "url": "img/teams/Lens.svg"
  },//ndryshime
  "Levante": {
      "name": "Levante",
      "url": "img/teams/Levante.svg"
  },
  "Levante UD": {
      "name": "Levante",
      "url": "img/teams/Levante.svg"
  },//ndryshime
  "Leyton Orient": {
      "name": "Leyton Orient",
      "url": "img/teams/Leyton Orient.svg"
  },
  "Leyton Orient London": {
      "name": "Leyton Orient",
      "url": "img/teams/Leyton Orient.svg"
  },//ndryshim
  "Lille": {
      "name": "Lille",
      "url": "img/teams/Lille.svg"
  },
  "Lille OSC": {
      "name": "Lille",
      "url": "img/teams/Lille.svg"
  },//ndryshime
  "Lincoln": {
      "name": "Lincoln",
      "url": "img/teams/Lincoln.svg"
  },
  "Lincoln City": {
      "name": "Lincoln",
      "url": "img/teams/Lincoln.svg"
  },//ndryshime
  "Liverpool": {
      "name": "Liverpool",
      "url": "img/teams/Liverpool.svg"
  },
  "Liverpool FC": {
      "name": "Liverpool",
      "url": "img/teams/Liverpool.svg"
  },//ndryshime
  "Livingston  Kit 2324": {
      "name": "Livingston  Kit 2324",
      "url": "img/teams/Livingston.svg"
  },
  "Livingston FC": {
      "name": "Livingston  Kit 2324",
      "url": "img/teams/Livingston.svg"
  },//ndryshime
  "Lorient": {
      "name": "Lorient",
      "url": "img/teams/Lorient.svg"
  },
  "FC Lorient": {
      "name": "Lorient",
      "url": "img/teams/Lorient.svg"
  },//ndryshime
  "Luton-Town--23-24": {
      "name": "Luton-Town--23-24",
      "url": "img/teams/Luton-Town-Home-23-24.svg"
  },
  "Luton Town": {
      "name": "Luton-Town--23-24",
      "url": "img/teams/Luton-Town-Home-23-24.svg"
  },//ndryshime
  "Lyon": {
      "name": "Lyon",
      "url": "img/teams/Lyon.svg"
  },
  "Olympique Lyon": {
      "name": "Lyon",
      "url": "img/teams/Lyon.svg"
  },//ndryshime
  "Magdeburg": {
      "name": "Magdeburg",
      "url": "img/teams/Magdeburg.svg"
  },
  "FC Magdeburg": {
      "name": "Magdeburg",
      "url": "img/teams/Magdeburg.svg"
  },//ndryshime
  "Maidenhead Utd": {
      "name": "Maidenhead Utd",
      "url": "img/teams/Maidenhead Utd.svg"
  },
  "Maidenhead United FC": {
      "name": "Maidenhead Utd",
      "url": "img/teams/Maidenhead Utd.svg"
  },//ndryshime
  "Mainz": {
      "name": "Mainz",
      "url": "img/teams/Mainz.svg"
  },
  "FSV Mainz": {
      "name": "Mainz",
      "url": "img/teams/Mainz.svg"
  },//ndryshime
  "Malaga": {
      "name": "Malaga",
      "url": "img/teams/Malaga.svg"
  },
  "Malaga CF": {
      "name": "Malaga",
      "url": "img/teams/Malaga.svg"
  },//ndryshime
  "CD Mirandes": {
      "name": "Malaga",
      "url": "img/teams/Malaga.svg"
  },
  "Mallorca": {
      "name": "Mallorca",
      "url": "img/teams/Mallorca.svg"
  },
  "RCD Mallorca": {
      "name": "Mallorca",
      "url": "img/teams/Mallorca.svg"
  },//ndryshime
  "Man City": {
      "name": "Man City",
      "url": "img/teams/Man City.svg"
  },
  "Manchester City": {
      "name": "Man City",
      "url": "img/teams/Man City.svg"
  },
  "Mansfield": {
      "name": "Mansfield",
      "url": "img/teams/Mansfield.svg"
  },
  "Mansfield Town": {
      "name": "Mansfield",
      "url": "img/teams/Mansfield.svg"
  },//ndryshime
  "Mantova": {
      "name": "Mantova",
      "url": "img/teams/Mantova.svg"
  },
  "Mantova 1911": {
      "name": "Mantova",
      "url": "img/teams/Mantova.svg"
  },//ndryshime
  "ManUtd20": {
      "name": "ManUtd20",
      "url": "img/teams/Man Utd.svg"
  },
  "Man Utd": {
      "name": "ManUtd20",
      "url": "img/teams/Man Utd.svg"
  },
  "Manchester Utd": {
      "name": "ManUtd20",
      "url": "img/teams/Man Utd.svg"
  },
  "Manchester United": {
      "name": "ManUtd20",
      "url": "img/teams/Man Utd.svg"
  },//ndryshime
  "Marseille": {
      "name": "Marseille",
      "url": "img/teams/Marseille.svg"
  },
  "Olympique Marseille": {
      "name": "Marseille",
      "url": "img/teams/Marseille.svg"
  },//ndryshime
  "Martigues": {
      "name": "Martigues",
      "url": "img/teams/Martigues.svg"
  },
  "FC Martigues": {
      "name": "Martigues",
      "url": "img/teams/Martigues.svg"
  },//ndryshime
  "Metz": {
      "name": "Metz",
      "url": "img/teams/Metz.svg"
  },
  "FC Metz": {
      "name": "Metz",
      "url": "img/teams/Metz.svg"
  },//ndryshime
  "Middlesborough": {
      "name": "Middlesborough",
      "url": "img/teams/Middlesborough.svg"
  },
  "Millwall": {
      "name": "Millwall",
      "url": "img/teams/Millwall.svg"
  },
  "Millwall FC": {
      "name": "Millwall",
      "url": "img/teams/Millwall.svg"
  },//ndryshime
  "Mirandes": {
      "name": "Mirandes",
      "url": "img/teams/Mirandes.svg"
  },
  "CD Mirandes": {
      "name": "Mirandes",
      "url": "img/teams/Mirandes.svg"
  },//ndryshime
  "MK Dons": {
      "name": "MK Dons",
      "url": "img/teams/MK Dons.svg"
  },
  "Milton Keynes Dons": {
      "name": "MK Dons",
      "url": "img/teams/MK Dons.svg"
  },//ndryshime
  "Modena": {
      "name": "Modena",
      "url": "img/teams/Modena.svg"
  },
  "Modena FC": {
      "name": "Modena",
      "url": "img/teams/Modena.svg"
  },//ndryshime
  "Monaco": {
      "name": "Monaco",
      "url": "img/teams/Monaco.svg"
  },
  "AS Monaco": {
      "name": "Monaco",
      "url": "img/teams/Monaco.svg"
  },//ndryshime
  "Montpellier": {
      "name": "Montpellier",
      "url": "img/teams/Montpellier.svg"
  },
  "Montpellier HSC": {
      "name": "Montpellier",
      "url": "img/teams/Montpellier.svg"
  },//ndryshime
  "Montrose": {
      "name": "Montrose",
      "url": "img/teams/Montrose.svg"
  },
  "Montrose FC": {
      "name": "Montrose",
      "url": "img/teams/Montrose.svg"
  },//ndryshime
  "Monza": {
      "name": "Monza",
      "url": "img/teams/Monza.svg"
  },
  "AC Monza": {
      "name": "Monza",
      "url": "img/teams/Monza.svg"
  },//ndryshime
  "Morcambe": {
      "name": "Morcambe",
      "url": "img/teams/Morcambe.svg"
  },
  "Moreirense": {
      "name": "Moreirense",
      "url": "img/teams/Moreirense.svg"
  },
  "Moreirense FC": {
      "name": "Moreirense",
      "url": "img/teams/Moreirense.svg"
  },//ndryshime
  "Morton": {
      "name": "Morton",
      "url": "img/teams/Morton.svg"
  },
  "Greenock Morton FC": {
      "name": "Morton",
      "url": "img/teams/Morton.svg"
  },//ndryshime
  "Motherwell": {
      "name": "Motherwell",
      "url": "img/teams/Motherwell.svg"
  },
  "Motherwell FC": {
      "name": "Motherwell",
      "url": "img/teams/Motherwell.svg"
  },//ndryshime
  "Nacional": {
      "name": "Nacional",
      "url": "img/teams/Nacional.svg"
  },
  "Nantes": {
      "name": "Nantes",
      "url": "img/teams/Nantes.svg"
  },
  "FC Nantes": {
      "name": "Nantes",
      "url": "img/teams/Nantes.svg"
  },//ndryshime
  "Napoli": {
      "name": "Napoli",
      "url": "img/teams/Napoli.svg"
  },
  "SSC Napoli": {
      "name": "Napoli",
      "url": "img/teams/Napoli.svg"
  },//ndryshime
  "Newcastle  Kit 20": {
      "name": "Newcastle  Kit 20",
      "url": "img/teams/Newcastle.svg"
  },
  "Newcastle United": {
      "name": "Newcastle  Kit 20",
      "url": "img/teams/Newcastle.svg"
  },//ndryshime
  "Newport County": {
      "name": "Newport County",
      "url": "img/teams/Newport County.svg"
  },
  "Newtown": {
      "name": "Newtown",
      "url": "img/teams/Newtown.svg"
  },
  "Newtown AFC": {
      "name": "Newtown",
      "url": "img/teams/Newtown.svg"
  },//ndryshime
  "Nice": {
      "name": "Nice",
      "url": "img/teams/Nice.svg"
  },
  "OGG Nice": {
      "name": "Nice",
      "url": "img/teams/Nice.svg"
  },//ndryshime
  "Northampton": {
      "name": "Northampton",
      "url": "img/teams/Northampton.svg"
  },
  "Northampton Town": {
      "name": "Northampton",
      "url": "img/teams/Northampton.svg"
  },//ndryshime
  "Norwich": {
      "name": "Norwich",
      "url": "img/teams/Norwich.svg"
  },
  "Norwich City": {
      "name": "Norwich",
      "url": "img/teams/Norwich.svg"
  },//ndryshime
  "Nottm Forest": {
      "name": "Nottm Forest",
      "url": "img/teams/Nottm Forest.svg"
  },
  "Nottingham Forest": {
      "name": "Nottm Forest",
      "url": "img/teams/Nottm Forest.svg"
  },//ndryshime
  "Notts County": {
      "name": "Notts County",
      "url": "img/teams/Notts County.svg"
  },
  "Notts County": {
      "name": "Notts County",
      "url": "img/teams/Notts County.svg"
  },//ndryshime
  "Nurnberg": {
      "name": "Nurnberg",
      "url": "img/teams/Nurnberg.svg"
  },
  "OH Leuven": {
      "name": "OH Leuven",
      "url": "img/teams/OH Leuven.svg"
  },
  "Oud-Heverlee Leuven": {
      "name": "OH Leuven",
      "url": "img/teams/OH Leuven.svg"
  },//ndryshime
  "Oldham": {
      "name": "Oldham",
      "url": "img/teams/Oldham.svg"
  },
  "Oldham Athletic": {
      "name": "Oldham",
      "url": "img/teams/Oldham.svg"
  },//ndryshime
  "Osasuna": {
      "name": "Osasuna",
      "url": "img/teams/Osasuna.svg"
  },
  "CA Osasuna": {
      "name": "Osasuna",
      "url": "img/teams/Osasuna.svg"
  },//ndryshime
  "Oxford Utd": {
      "name": "Oxford Utd",
      "url": "img/teams/Oxford Utd.svg"
  },
  "Oxford United": {
      "name": "Oxford Utd",
      "url": "img/teams/Oxford Utd.svg"
  },//ndryshime
  "Paderborn": {
      "name": "Paderborn",
      "url": "img/teams/Paderborn.svg"
  },
  "SC Paderborn 07": {
      "name": "Paderborn",
      "url": "img/teams/Paderborn.svg"
  },//ndryshime
  "Palermo": {
      "name": "Palermo",
      "url": "img/teams/Palermo.svg"
  },
  "Palermo FC": {
      "name": "Palermo",
      "url": "img/teams/Palermo.svg"
  },//ndryshime
  "Paris FC": {
      "name": "Paris FC",
      "url": "img/teams/Paris FC.svg"
  },
  "Parma": {
      "name": "Parma",
      "url": "img/teams/Parma.svg"
  },
  "Parma Calcio": {
      "name": "Parma",
      "url": "img/teams/Parma.svg"
  },//ndryshime
  "Partick": {
      "name": "Partick",
      "url": "img/teams/Partick.svg"
  },
  "Partick Thistle FC": {
      "name": "Partick",
      "url": "img/teams/Partick.svg"
  },//ndryshime
  "Pau": {
      "name": "Pau",
      "url": "img/teams/Pau.svg"
  },
  "Pau FC": {
      "name": "Pau",
      "url": "img/teams/Pau.svg"
  },//ndryshime
  "Penybont": {
      "name": "Penybont",
      "url": "img/teams/Penybont.svg"
  },
  "Peterborough": {
      "name": "Peterborough",
      "url": "img/teams/Peterborough.svg"
  },
  "Peterborough United": {
      "name": "Peterborough",
      "url": "img/teams/Peterborough.svg"
  },//ndryshime
  "Peterhead": {
      "name": "Peterhead",
      "url": "img/teams/Peterhead.svg"
  },
  "Peterhead FC": {
      "name": "Peterhead",
      "url": "img/teams/Peterhead.svg"
  },//ndryshime
  "Pisa": {
      "name": "Pisa",
      "url": "img/teams/Pisa.svg"
  },
  "Pisa SC": {
      "name": "Pisa",
      "url": "img/teams/Pisa.svg"
  },//ndryshime
  "Plymouth": {
      "name": "Plymouth",
      "url": "img/teams/Plymouth.svg"
  },
  "Plymouth Argyle": {
      "name": "Plymouth",
      "url": "img/teams/Plymouth.svg"
  },//ndryshime
  "Port Vale": {
      "name": "Port Vale",
      "url": "img/teams/Port Vale.svg"
  },
  "Portsmouth": {
      "name": "Portsmouth",
      "url": "img/teams/Portsmouth.svg"
  },
  "Portsmouth FC": {
      "name": "Portsmouth",
      "url": "img/teams/Portsmouth.svg"
  },//ndryshime
  "Preston": {
      "name": "Preston",
      "url": "img/teams/Preston.svg"
  },
  "Preston North End": {
      "name": "Preston",
      "url": "img/teams/Preston.svg"
  },//ndryshime
  "PSG": {
      "name": "PSG",
      "url": "img/teams/PSG.svg"
  },
  "QPR": {
      "name": "QPR",
      "url": "img/teams/QPR.svg"
  },
  "Queen of South": {
      "name": "Queen of South",
      "url": "img/teams/Queen of South.svg"
  },
  "Queen of South FC": {
      "name": "Queen of South",
      "url": "img/teams/Queen of South.svg"
  },//ndryshime
  "Queens Park": {
      "name": "Queens Park",
      "url": "img/teams/Queens Park.svg"
  },
  "Queens Park Rangers": {
      "name": "Queens Park",
      "url": "img/teams/Queens Park.svg"
  },//ndryshime
  "Racing Ferrol": {
      "name": "Racing Ferrol",
      "url": "img/teams/Racing Ferrol.svg"
  },
  "Racing Club de Ferrol": {
      "name": "Racing Ferrol",
      "url": "img/teams/Racing Ferrol.svg"
  },//ndryshime
  "Racing Santander": {
      "name": "Racing Santander",
      "url": "img/teams/Racing Santander.svg"
  },
  "Raith": {
      "name": "Raith",
      "url": "img/teams/Raith.svg"
  },
  "Raith Rovers FC": {
      "name": "Raith",
      "url": "img/teams/Raith.svg"
  },//ndryshime
  "Rangers": {
      "name": "Rangers",
      "url": "img/teams/Rangers.svg"
  },
  "Cove Rangers FC": {
      "name": "Cove Rangers",
      "url": "img/teams/Cove Rangers.svg"
  },//ndryshime
  "Rapid Vienna II": {
      "name": "Rapid Vienna II",
      "url": "img/teams/Rapid Vienna II.svg"
  },
  "Rapid Vienna": {
      "name": "Rapid Vienna",
      "url": "img/teams/Rapid Vienna.svg"
  },
  "Rayo Vallecano": {
      "name": "Rayo Vallecano",
      "url": "img/teams/Rayo Vallecano.svg"
  },
  "RB Leipzig": {
      "name": "RB Leipzig",
      "url": "img/teams/RB Leipzig.svg"
  },
  "Reading": {
      "name": "Reading",
      "url": "img/teams/Reading.svg"
  },
  "Reading FC": {
      "name": "Reading",
      "url": "img/teams/Reading.svg"
  },//ndryshime
  "Real Betis": {
      "name": "Real Betis",
      "url": "img/teams/Real Betis.svg"
  },
  "Real Betis Seville": {
      "name": "Real Betis",
      "url": "img/teams/Real Betis.svg"
  },//ndryshime
  "Real Madrid": {
      "name": "Real Madrid",
      "url": "img/teams/Real Madrid.svg"
  },
  "Real Oviedo": {
      "name": "Real Oviedo",
      "url": "img/teams/Real Oviedo.svg"
  },
  "Real Sociedad": {
      "name": "Real Sociedad",
      "url": "img/teams/Real Sociedad.svg"
  },
  "Real Sociedad San Sebastian": {
      "name": "Real Sociedad",
      "url": "img/teams/Real Sociedad.svg"
  },//ndryshime
  "Real Zaragoza": {
      "name": "Real Zaragoza",
      "url": "img/teams/Real Zaragoza.svg"
  },
  "Red Star FC 93": {
      "name": "Red Star FC 93",
      "url": "img/teams/Red Star FC 93.svg"
  },
  "Red Star FC": {
      "name": "Red Star FC 93",
      "url": "img/teams/Red Star FC 93.svg"
  },//ndryshime
  "Reims": {
      "name": "Reims",
      "url": "img/teams/Reims.svg"
  },
  "Stade Reims": {
      "name": "Reims",
      "url": "img/teams/Reims.svg"
  },//ndryshime
  "Rennais": {
      "name": "Rennais",
      "url": "img/teams/Rennais.svg"
  },
  "Rio Ave": {
      "name": "Rio Ave",
      "url": "img/teams/Rio Ave.svg"
  },
  "Rio Ave FC": {
      "name": "Rio Ave",
      "url": "img/teams/Rio Ave.svg"
  },//ndryshime
  "Rochdale": {
      "name": "Rochdale",
      "url": "img/teams/Rochdale.svg"
  },
  "Rochdale AFC": {
      "name": "Rochdale",
      "url": "img/teams/Rochdale.svg"
  },//ndryshime
  "Rodez": {
      "name": "Rodez",
      "url": "img/teams/Rodez.svg"
  },
  "Rodez Aveyron Football": {
      "name": "Rodez",
      "url": "img/teams/Rodez.svg"
  },//ndryshime
  "Roma": {
      "name": "Roma",
      "url": "img/teams/Roma.svg"
  },
  "AS Roma": {
      "name": "Roma",
      "url": "img/teams/Roma.svg"
  },//ndryshime
  "Ross County": {
      "name": "Ross County",
      "url": "img/teams/Ross County.svg"
  },
  "Ross County FC": {
      "name": "Ross County",
      "url": "img/teams/Ross County.svg"
  },//ndryshime
  "Rotherham": {
      "name": "Rotherham",
      "url": "img/teams/Rotherham.svg"
  },
  "Rotherham United": {
      "name": "Rotherham",
      "url": "img/teams/Rotherham.svg"
  },//ndryshime
  "Salernitana": {
      "name": "Salernitana",
      "url": "img/teams/Salernitana.svg"
  },
  "US Salernitana": {
      "name": "Salernitana",
      "url": "img/teams/Salernitana.svg"
  },//ndryshime
  "Salford": {
      "name": "Salford",
      "url": "img/teams/Salford.svg"
  },
  "Salford City": {
      "name": "Salford",
      "url": "img/teams/Salford.svg"
  },//ndryshime
  "Sampdoria": {
      "name": "Sampdoria",
      "url": "img/teams/Sampdoria.svg"
  },
  "Sampdoria Genoa": {
      "name": "Sampdoria",
      "url": "img/teams/Sampdoria.svg"
  },//ndryshime
  "Santa Clara": {
      "name": "Santa Clara",
      "url": "img/teams/Santa Clara.svg"
  },
  "Santa Clara Azores": {
      "name": "Santa Clara",
      "url": "img/teams/Santa Clara.svg"
  },//ndryshime
  "Sassuolo": {
      "name": "Sassuolo",
      "url": "img/teams/Sassuolo.svg"
  },
  "Sassuolo Calcio": {
      "name": "Sassuolo",
      "url": "img/teams/Sassuolo.svg"
  },//ndryshime
  "SC Bastia": {
      "name": "SC Bastia",
      "url": "img/teams/SC Bastia.svg"
  },
  "SC Farense": {
      "name": "SC Farense",
      "url": "img/teams/SC Farense.svg"
  },
  "SC Freiburg": {
      "name": "SC Freiburg",
      "url": "img/teams/SC Freiburg.svg"
  },
  "SC Preussen Munster": {
      "name": "SC Preussen Munster",
      "url": "img/teams/SC Preussen Munster.svg"
  },
  "SC Preussen 06 Munster": {
      "name": "SC Preussen Munster",
      "url": "img/teams/SC Preussen Munster.svg"
  },//ndryshime
  "Schalke": {
      "name": "Schalke",
      "url": "img/teams/Schalke.svg"
  },
  "Schalke 04": {
      "name": "Schalke",
      "url": "img/teams/Schalke.svg"
  },//ndryshime
  "SCR Altach": {
      "name": "SCR Altach",
      "url": "img/teams/SCR Altach.svg"
  },
  "Sevilla": {
      "name": "Sevilla",
      "url": "img/teams/Sevilla.svg"
  },
  "Sevilla FC": {
      "name": "Sevilla",
      "url": "img/teams/Sevilla.svg"
  },//ndryshime
  "Sheffield United": {
      "name": "Sheffield United",
      "url": "img/teams/Sheffield United.svg"
  },
  "Sheffield Wednesday": {
      "name": "Sheffield Wednesday",
      "url": "img/teams/Sheffield Wednesday.svg"
  },
  "Shrewsbury": {
      "name": "Shrewsbury",
      "url": "img/teams/Shrewsbury.svg"
  },
  "Shrewsbury Town": {
      "name": "Shrewsbury",
      "url": "img/teams/Shrewsbury.svg"
  },//ndryshime
  "Sint-Truidense": {
      "name": "Sint-Truidense",
      "url": "img/teams/Sint-Truidense.svg"
  },
  "St. Truidense": {
      "name": "Sint-Truidense",
      "url": "img/teams/Sint-Truidense.svg"
  },//ndryshime
  "SK Sturm Graz II": {
      "name": "SK Sturm Graz II",
      "url": "img/teams/SK Sturm Graz II.svg"
  },
  "SK Sturm Graz": {
      "name": "SK Sturm Graz",
      "url": "img/teams/SK Sturm Graz.svg"
  },//ndryshime
  "SKU Amstetten": {
      "name": "SKU Amstetten",
      "url": "img/teams/SKU Amstetten.svg"
  },
  "Solihull Moors": {
      "name": "Solihull Moors",
      "url": "img/teams/Solihull Moors.svg"
  },
  "Solihull Moors FC": {
      "name": "Solihull Moors",
      "url": "img/teams/Solihull Moors.svg"
  },//ndryshime
  "Southampton": {
      "name": "Southampton",
      "url": "img/teams/Southampton.svg"
  },
  "Southampton FC": {
      "name": "Southampton",
      "url": "img/teams/Southampton.svg"
  },//ndryshime
  "Southend": {
      "name": "Southend",
      "url": "img/teams/Southend.svg"
  },
  "Southend United": {
      "name": "Southend",
      "url": "img/teams/Southend.svg"
  },//ndryshime
  "Spartans FC": {
      "name": "Spartans FC",
      "url": "img/teams/Spartans FC.svg"
  },
  "Spezia": {
      "name": "Spezia",
      "url": "img/teams/Spezia.svg"
  },
  "Spezia Calcio": {
      "name": "Spezia",
      "url": "img/teams/Spezia.svg"
  },//ndryshime
  "Sporting": {
      "name": "Sporting",
      "url": "img/teams/Sporting.svg"
  },
  "Sporting Gijon": {
      "name": "Sporting Gijon",
      "url": "img/teams/Sporting Gijon.svg"
  },//ndryshime
  "SSV Ulm 1846": {
      "name": "SSV Ulm 1846",
      "url": "img/teams/SSV Ulm 1846.svg"
  },
  "St Johnstone": {
      "name": "St Johnstone",
      "url": "img/teams/St Johnstone.svg"
  },
  "St. Johnstone FC": {
      "name": "St Johnstone",
      "url": "img/teams/St Johnstone.svg"
  },//ndryshime
  "St Pauli": {
      "name": "St Pauli",
      "url": "img/teams/St Pauli.svg"
  },
  "FC St. Pauli": {
      "name": "St Pauli",
      "url": "img/teams/St Pauli.svg"
  },//ndryshime
  "St Polten": {
      "name": "St Polten",
      "url": "img/teams/St Polten.svg"
  },
  "St-Étienne": {
      "name": "St-Étienne",
      "url": "img/teams/St-Étienne.svg"
  },
  "AS Saint-Etienne": {
      "name": "St-Étienne",
      "url": "img/teams/St-Étienne.svg"
  },//ndryshime
  "St. Mirren": {
      "name": "St. Mirren",
      "url": "img/teams/St. Mirren.svg"
  },
  "St Mirren FC": {
      "name": "St. Mirren",
      "url": "img/teams/St. Mirren.svg"
  },//ndryshime
  "Standard Liege": {
      "name": "Standard Liege",
      "url": "img/teams/Standard Liege.svg"
  },
  "Stenhousemuir": {
      "name": "Stenhousemuir",
      "url": "img/teams/Stenhousemuir.svg"
  },
  "Stenhousemuir FC": {
      "name": "Stenhousemuir",
      "url": "img/teams/Stenhousemuir.svg"
  },//ndryshime
  "Stevenage -   Design": {
      "name": "Stevenage -   Design",
      "url": "img/teams/Stevenage.svg"
  },
  "Stevenage FC": {
      "name": "Stevenage -   Design",
      "url": "img/teams/Stevenage.svg"
  },//ndryshime
  "Stirling": {
      "name": "Stirling",
      "url": "img/teams/Stirling.svg"
  },
  "Stirling Albion FC": {
      "name": "Stirling",
      "url": "img/teams/Stirling.svg"
  },//ndryshime
  "Stockport": {
      "name": "Stockport",
      "url": "img/teams/Stockport.svg"
  },
  "Stockport County FC": {
      "name": "Stockport",
      "url": "img/teams/Stockport.svg"
  },//ndryshime
  "Stoke": {
      "name": "Stoke",
      "url": "img/teams/Stoke.svg"
  },
  "Stoke City": {
      "name": "Stoke",
      "url": "img/teams/Stoke.svg"
  },//ndryshime
  "Stranraer": {
      "name": "Stranraer",
      "url": "img/teams/Stranraer.svg"
  },
  "Stranraer FC": {
      "name": "Stranraer",
      "url": "img/teams/Stranraer.svg"
  },//ndryshime
  "Strasbourg": {
      "name": "Strasbourg",
      "url": "img/teams/Strasbourg.svg"
  },
  "Strasbourg Alsace": {
      "name": "Strasbourg",
      "url": "img/teams/Strasbourg.svg"
  },//ndryshime
  "Sudtirol": {
      "name": "Sudtirol",
      "url": "img/teams/Sudtirol.svg"
  },
  "FC Sudtirol Bolzano": {
      "name": "Sudtirol",
      "url": "img/teams/Sudtirol.svg"
  },//ndryshime
  "Sunderland": {
      "name": "Sunderland",
      "url": "img/teams/Sunderland.svg"
  },
  "Sunderland AFC": {
      "name": "Sunderland",
      "url": "img/teams/Sunderland.svg"
  },//ndryshime
  "Sutton  23-24": {
      "name": "Sutton  23-24",
      "url": "img/teams/Sutton.svg"
  },
  "Sutton United": {
      "name": "Sutton  23-24",
      "url": "img/teams/Sutton.svg"
  },//ndryshime
  "SV Horn": {
      "name": "SV Horn",
      "url": "img/teams/SV Horn.svg"
  },
  "SV Kapfenberg": {
      "name": "SV Kapfenberg",
      "url": "img/teams/SV Kapfenberg.svg"
  },
  "SV Lafnitz": {
      "name": "SV Lafnitz",
      "url": "img/teams/SV Lafnitz.svg"
  },
  "SV Ried": {
      "name": "SV Ried",
      "url": "img/teams/SV Ried.svg"
  },
  "SV Stripfing Weiden": {
      "name": "SV Stripfing Weiden",
      "url": "img/teams/SV Stripfing Weiden.svg"
  },
  "SW Bregenz": {
      "name": "SW Bregenz",
      "url": "img/teams/SW Bregenz.svg"
  },
  "Swansea": {
      "name": "Swansea",
      "url": "img/teams/Swansea.svg"
  },
  "Swansea City": {
      "name": "Swansea",
      "url": "img/teams/Swansea.svg"
  },//ndryshime
  "Swindon Town": {
      "name": "Swindon Town",
      "url": "img/teams/Swindon Town.svg"
  },
  "Tamworth": {
      "name": "Tamworth",
      "url": "img/teams/Tamworth.svg"
  },
  "Tamworth FC": {
      "name": "Tamworth",
      "url": "img/teams/Tamworth.svg"
  },//ndryshime
  "Tenerife": {
      "name": "Tenerife",
      "url": "img/teams/Tenerife.svg"
  },
  "Tenerife CD": {
      "name": "Tenerife",
      "url": "img/teams/Tenerife.svg"
  },//ndryshime
  "The New Saints": {
      "name": "The New Saints",
      "url": "img/teams/The New Saints.svg"
  },
  "The New Saints FC": {
      "name": "The New Saints",
      "url": "img/teams/The New Saints.svg"
  },//ndryshime
  "Torino": {
      "name": "Torino",
      "url": "img/teams/Torino.svg"
  },
  "Torino FC": {
      "name": "Torino",
      "url": "img/teams/Torino.svg"
  },//ndryshime
  "Tottenham": {
      "name": "Tottenham",
      "url": "img/teams/Tottenham.svg"
  },
  "Tottenham Hotspur FC": {
      "name": "Tottenham",
      "url": "img/teams/Tottenham.svg"
  },//ndryshime
  "Toulouse": {
      "name": "Toulouse",
      "url": "img/teams/Toulouse.svg"
  },
  "Toulouse FC": {
      "name": "Toulouse",
      "url": "img/teams/Toulouse.svg"
  },//ndryshime
  "Tranmere Rovers": {
      "name": "Tranmere Rovers",
      "url": "img/teams/Tranmere Rovers.svg"
  },
  "Tranmere Rovers FC": {
      "name": "Tranmere Rovers",
      "url": "img/teams/Tranmere Rovers.svg"
  },//ndryshime
  "Troyes": {
      "name": "Troyes",
      "url": "img/teams/Troyes.svg"
  },
  "ESTAC Troyes": {
      "name": "Troyes",
      "url": "img/teams/Troyes.svg"
  },//ndryshime
  "TSG Hoffenheim": {
      "name": "TSG Hoffenheim",
      "url": "img/teams/TSG Hoffenheim.svg"
  },
  "Udinese": {
      "name": "Udinese",
      "url": "img/teams/Udinese.svg"
  },
  "Udinese Calcio": {
      "name": "Udinese",
      "url": "img/teams/Udinese.svg"
  },//ndryshime
  "Union Berlin": {
      "name": "Union Berlin",
      "url": "img/teams/Union Berlin.svg"
  },
  "Union Saint Gilloise": {
      "name": "Union Saint Gilloise",
      "url": "img/teams/Union Saint Gilloise.svg"
  },
  "Union Saint-Gilloise": {
      "name": "Union Saint Gilloise",
      "url": "img/teams/Union Saint Gilloise.svg"
  },//ndryshime
  "Valencia": {
      "name": "Valencia",
      "url": "img/teams/Valencia.svg"
  },
  "Valencia CF": {
      "name": "Valencia",
      "url": "img/teams/Valencia.svg"
  },//ndryshime
  "Valladolid": {
      "name": "Valladolid",
      "url": "img/teams/Valladolid.svg"
  },
  "Real Valladolid": {
      "name": "Valladolid",
      "url": "img/teams/Valladolid.svg"
  },//ndryshime
  "Venezia": {
      "name": "Venezia",
      "url": "img/teams/Venezia.svg"
  },
  "Venezia": {
      "name": "Venezia",
      "url": "img/teams/Venezia.svg"
  },//ndryshime
  "Verona": {
      "name": "Verona",
      "url": "img/teams/Verona.svg"
  },
  "Hellas Verona": {
      "name": "Verona",
      "url": "img/teams/Verona.svg"
  },
  "VfB Stuttgart": {
      "name": "VfB Stuttgart",
      "url": "img/teams/VfB Stuttgart.svg"
  },
  "VfB Stuttgart II": {
      "name": "VfB Stuttgart",
      "url": "img/teams/VfB Stuttgart.svg"
  },//ndryshime
  "VfL Bochum": {
      "name": "VfL Bochum",
      "url": "img/teams/VfL Bochum.svg"
  },
  "Villarreal": {
      "name": "Villarreal",
      "url": "img/teams/Villarreal.svg"
  },
  "Villarreal CF": {
      "name": "Villarreal",
      "url": "img/teams/Villarreal.svg"
  },//ndryshime
  "Walsall": {
      "name": "Walsall",
      "url": "img/teams/Walsall.svg"
  },
  "Walsall FC": {
      "name": "Walsall",
      "url": "img/teams/Walsall.svg"
  },//ndryshime
  "Watford": {
      "name": "Watford",
      "url": "img/teams/Watford.svg"
  },
  "Watford FC": {
      "name": "Watford",
      "url": "img/teams/Watford.svg"
  },//ndryshime
  "Wealdstone": {
      "name": "Wealdstone",
      "url": "img/teams/Wealdstone.svg"
  },
  "Wealdstone FC": {
      "name": "Wealdstone",
      "url": "img/teams/Wealdstone.svg"
  },//ndryshime
  "Werder Bremen": {
      "name": "Werder Bremen",
      "url": "img/teams/Werder Bremen.svg"
  },
  "West Brom": {
      "name": "West Brom",
      "url": "img/teams/West Brom.svg"
  },
  "West Ham": {
      "name": "West Ham",
      "url": "img/teams/West Ham.svg"
  },
  "West Ham United": {
      "name": "West Ham",
      "url": "img/teams/West Ham.svg"
  },
  "Westerlo": {
      "name": "Westerlo",
      "url": "img/teams/Westerlo.svg"
  },
  "KVC Westerlo": {
      "name": "Westerlo",
      "url": "img/teams/Westerlo.svg"
  },//ndryshime
  "Wigan": {
      "name": "Wigan",
      "url": "img/teams/Wigan.svg"
  },
  "Wigan Athletic": {
      "name": "Wigan",
      "url": "img/teams/Wigan.svg"
  },//ndryshime
  "Woking": {
      "name": "Woking",
      "url": "img/teams/Woking.svg"
  },
  "Woking FC": {
      "name": "Woking",
      "url": "img/teams/Woking.svg"
  },//ndryshime
  "Wolfsberger AC": {
      "name": "Wolfsberger AC",
      "url": "img/teams/Wolfsberger AC.svg"
  },
  "Wolfsburg": {
      "name": "Wolfsburg",
      "url": "img/teams/Wolfsburg.svg"
  },
  "Wolfsburg AC": {
      "name": "Wolfsburg",
      "url": "img/teams/Wolfsburg.svg"
  },//ndryshime
  "Wolverhampton": {
      "name": "Wolverhampton",
      "url": "img/teams/Wolverhampton.svg"
  },
  "Wolverhampton Wanderers": {
      "name": "Wolverhampton",
      "url": "img/teams/Wolverhampton.svg"
  },//ndryshime
  "Wrexham": {
      "name": "Wrexham",
      "url": "img/teams/Wrexham.svg"
  },
  "Wrexham AFC": {
      "name": "Wrexham",
      "url": "img/teams/Wrexham.svg"
  },//ndryshime
  "WSG Swarovski Tirol": {
      "name": "WSG Swarovski Tirol",
      "url": "img/teams/WSG Swarovski Tirol.svg"
  },
  "WSG Tirol": {
      "name": "WSG Swarovski Tirol",
      "url": "img/teams/WSG Swarovski Tirol.svg"
  },//ndryshime
  "Wycombe Wanderers": {
      "name": "Wycombe Wanderers",
      "url": "img/teams/Wycombe Wanderers.svg"
  },
  "Yeovil": {
      "name": "Yeovil",
      "url": "img/teams/Yeovil.svg"
  },
  "Yeovil Town": {
      "name": "Yeovil",
      "url": "img/teams/Yeovil.svg"
  },//ndryshime
  "York": {
      "name": "York",
      "url": "img/teams/York.svg"
  },
  "York City FC": {
      "name": "York",
      "url": "img/teams/York.svg"
  },//ndryshime
  "spain": {
      "name": "Spain",
      "url": "img/teams/spain kombetare.svg"
  },
  "germany": {
      "name": "Germany",
      "url": "img/teams/germany.svg"
  },
  "czechrepublic": {
      "name": "Czech Republic",
      "url": "img/teams/NoKit.svg"
  },
  "belgium": {
      "name": "Belgium",
      "url": "img/teams/belgium.svg"
  },
  "switzerland": {
      "name": "Switzerland",
      "url": "img/teams/switzerland.svg"
  },
  "france": {
      "name": "France",
      "url": "img/teams/france.svg"
  },
  "finland": {
      "name": "Finland",
      "url": "img/teams/finland.svg"
  },
  "italy": {
      "name": "Italy",
      "url": "img/teams/italy kombetare.svg"
  },
  "estonia": {
      "name": "Estonia",
      "url": "img/teams/estonia.svg"
  },
  "portugal": {
      "name": "Portugal",
      "url": "img/teams/portugal.svg"
  },
  "andorra": {
      "name": "Andorra",
      "url": "img/teams/andorra.svg"
  },
  "poland": {
      "name": "Poland",
      "url": "img/teams/poland.svg"
  },
  "ukraine": {
      "name": "Ukraine",
      "url": "img/teams/ukraine.svg"
  },
  "denmark": {
      "name": "Denmark",
      "url": "img/teams/denmark.svg"
  },
  "sweden": {
      "name": "Sweden",
      "url": "img/teams/sweden.svg"
  },
  "greece": {
      "name": "Greece",
      "url": "img/teams/greece.svg"
  },
  "cyprus": {
      "name": "Cyprus",
      "url": "img/teams/cyprus.svg"
  },
  "turkey": {
      "name": "Turkey",
      "url": "img/teams/turkey.svg"
  },
  "croatia": {
      "name": "Croatia",
      "url": "img/teams/croatia.svg"
  },
  "norway": {
      "name": "Norway",
      "url": "img/teams/norway.svg"
  },
  "israel": {
      "name": "Israel",
      "url": "img/teams/NoKit.svg"
  },
  "romania": {
      "name": "Romania",
      "url": "img/teams/romania.svg"
  },
  "belarus": {
      "name": "Belarus",
      "url": "img/teams/belarus.svg"
  },
  "bulgaria": {
      "name": "Bulgaria",
      "url": "img/teams/bulgaria.svg"
  },
  "gibraltar": {
      "name": "Gibraltar",
      "url": "img/teams/gibraltar.svg"
  },
  "england": {
      "name": "England",
      "url": "img/teams/england.svg"
  },
  "repofireland": {
      "name": "Republic of Ireland",
      "url": "img/teams/repofireland.svg"
  },
  "serbia": {
      "name": "Serbia",
      "url": "img/teams/serbia.svg"
  },
  "scotland": {
      "name": "Scotland",
      "url": "img/teams/scotland.svg"
  },
  "colombia": {
      "name": "Colombia",
      "url": "img/teams/colombia.svg"
  },
  "uruguay": {
      "name": "Uruguay",
      "url": "img/teams/uruguay.svg"
  },
  "brazil": {
      "name": "Brazil",
      "url": "img/teams/brazil.svg"
  },
  "venezuela": {
      "name": "Venezuela",
      "url": "img/teams/venezuela.svg"
  },
  "chile": {
      "name": "Chile",
      "url": "img/teams/chile.svg"
  },
  "peru": {
      "name": "Peru",
      "url": "img/teams/peru.svg"
  },
  "japan": {
      "name": "Japan",
      "url": "img/teams/japan.svg"
  },
  "panama": {
      "name": "Panama",
      "url": "img/teams/panama.svg"
  },
  "nigeria": {
      "name": "Nigeria",
      "url": "img/teams/nigeria.svg"
  },
  "sierraleone": {
      "name": "Sierra Leone",
      "url": "img/teams/sierraleone.svg"
  },
  "costarica": {
      "name": "Costa Rica",
      "url": "img/teams/costarica.svg"
  },
  "qatar": {
      "name": "Qatar",
      "url": "img/teams/qatar.svg"
  },
  "bangladesh": {
      "name": "Bangladesh",
      "url": "img/teams/bangladesh.svg"
  },
  "nepal": {
      "name": "Nepal",
      "url": "img/teams/NoKit.svg"
  },
  "morocco": {
      "name": "Morocco",
      "url": "img/teams/morocco.svg"
  },
  "centralafricanrepublic": {
      "name": "Central African Republic",
      "url": "img/teams/centralafricanrepublic.svg"
  },
  "southafrica": {
      "name": "South Africa",
      "url": "img/teams/southafrica.svg"
  },
  "saotomeepricipe": {
      "name": "Sao Tome and Principe",
      "url": "img/teams/saotomeepricipe.svg"
  },
  "tunisia": {
      "name": "Tunisia",
      "url": "img/teams/tunisia.svg"
  },
  "tanzania": {
      "name": "Tanzania",
      "url": "img/teams/tanzania.svg"
  },
  "netherlands": {
      "name": "Netherlands",
      "url": "img/teams/Netherlands kombetare.svg"
  },


  
  "Udinese Calcio": {
      "name": "Udinese Calcio",
      "url": "img/teams/Udinese.svg"
  },
  "Aarau": {
      "name": "Aarau",
      "url": "img/teams/FC Aarau.svg"
  },
  "FC Aarau": {
      "name": "FC Aarau",
      "url": "img/teams/FC Aarau.svg"
  },//ndryshime
  "Ac Bellinzona": {
      "name": "Ac Bellinzona",
      "url": "img/teams/AC Bellinzona.svg"
  },
  "ACS Sepsi": {
      "name": "ACS Sepsi",
      "url": "img/teams/ACS Sepsi.svg"
  },
  "Adana Demirspor": {
      "name": "Adana Demirspor",
      "url": "img/teams/Adana Demirspor.svg"
  },
  "Adelaide United": {
      "name": "Adelaide United",
      "url": "img/teams/Adelaide United.svg"
  },
  "Adelaide United FC": {
      "name": "Adelaide United FC",
      "url": "img/teams/Adelaide United.svg"
  },//ndryshime
  "ADO Den Haag": {
      "name": "ADO Den Haag",
      "url": "img/teams/ADO Den Haag.svg"
  },
  "AFC Hermannstadt": {
      "name": "AFC Hermannstadt",
      "url": "img/teams/AFC Hermannstadt.svg"
  },
  "Ajax": {
      "name": "Ajax",
      "url": "img/teams/Ajax.svg"
  },
  "Ajax Amsterdam": {
      "name": "Ajax Amsterdam",
      "url": "img/teams/Ajax.svg"
  },//ndryshime
  "Alanyaspor": {
      "name": "Alanyaspor",
      "url": "img/teams/Alanyaspor.svg"
  },
  "Almere City FC": {
      "name": "Almere City FC",
      "url": "img/teams/Almere City FC.svg"
  },
  "Antalyaspor": {
      "name": "Antalyaspor",
      "url": "img/teams/Antalyaspor.svg"
  },
  "Argentinos Jrs": {
      "name": "Argentinos Jrs",
      "url": "img/teams/Argentinos Jrs.svg"
  },
  "Argentinos Juniors": {
      "name": "Argentinos Juniors",
      "url": "img/teams/Argentinos Jrs.svg"
  },//ndryshime
  "AS Trencin": {
      "name": "AS Trencin",
      "url": "img/teams/AS Trencin.svg"
  },
  "Atlas": {
      "name": "Atlas",
      "url": "img/teams/Atlas.svg"
  },
  "Atlas FC": {
      "name": "Atlas FC",
      "url": "img/teams/Atlas.svg"
  },//ndryshime
  "Atletico San Luis": {
      "name": "Atletico San Luis",
      "url": "img/teams/Atletico San Luis.svg"
  },
  "Atlético Tucumán": {
      "name": "Atlético Tucumán",
      "url": "img/teams/Atlético Tucumán.svg"
  },
  "Atletico Tucuman": {
      "name": "Atletico Tucuman",
      "url": "img/teams/Atlético Tucumán.svg"
  },//ndryshime
  "Auckland FC": {
      "name": "Auckland FC",
      "url": "img/teams/Auckland FC.svg"
  },
  "AZ Reserves": {
      "name": "AZ Reserves",
      "url": "img/teams/AZ Reserves.svg"
  },
  "AZ": {
      "name": "AZ",
      "url": "img/teams/AZ.svg"
  },
  "AZ Alkmaar": {
      "name": "AZ Alkmaar",
      "url": "img/teams/AZ.svg"
  },//ndryshime
  "Ballymena Utd": {
      "name": "Ballymena Utd",
      "url": "img/teams/Ballymena Utd.svg"
  },
  "Ballymena United": {
      "name": "Ballymena United",
      "url": "img/teams/Ballymena Utd.svg"
  },//ndryshime
  "Banfield": {
      "name": "Banfield",
      "url": "img/teams/Banfield.svg"
  },
  "CA Banfield": {
      "name": "CA Banfield",
      "url": "img/teams/Banfield.svg"
  },//ndryshime
  "Barracas Central": {
      "name": "Barracas Central",
      "url": "img/teams/Barracas Central.svg"
  },
  "CA Barracas Central": {
      "name": "CA Barracas Central",
      "url": "img/teams/Barracas Central.svg"
  },//ndryshime
  "Belgrano": {
      "name": "Belgrano",
      "url": "img/teams/Belgrano.svg"
  },
  "CA Belgrano de Cordoba": {
      "name": "CA Belgrano de Cordoba",
      "url": "img/teams/Belgrano.svg"
  },//ndryshime
  "Besiktas": {
      "name": "Besiktas",
      "url": "img/teams/Besiktas.svg"
  },
  "Besiktas Istanbul": {
      "name": "Besiktas Istanbul",
      "url": "img/teams/Besiktas.svg"
  },//ndryshime
  "Boca Juniors": {
      "name": "Boca Juniors",
      "url": "img/teams/Boca Juniors.svg"
  },
  "Bodrum FK": {
      "name": "Bodrum FK",
      "url": "img/teams/Bodrum FK.svg"
  },
  "BB Bodrumspor": {
      "name": "BB Bodrumspor",
      "url": "img/teams/Bodrum FK.svg"
  },
  "Brisbane Roar": {
      "name": "Brisbane Roar",
      "url": "img/teams/Brisbane Roar.svg"
  },
  "Brisbane Roar FC": {
      "name": "Brisbane Roar FC",
      "url": "img/teams/Brisbane Roar.svg"
  },//ndryshime
  "CA Independiente": {
      "name": "CA Independiente",
      "url": "img/teams/CA Independiente.svg"
  },
  "CA Independiente Avellaneda": {
      "name": "CA Independiente Avellaneda",
      "url": "img/teams/CA Independiente.svg"
  },//ndryshime
  "CA Platense": {
      "name": "CA Platense",
      "url": "img/teams/CA Platense.svg"
  },
  "CA Talleres de Córdoba": {
      "name": "CA Talleres de Córdoba",
      "url": "img/teams/CA Talleres de Córdoba.svg"
  },
  "CA Tigre": {
      "name": "CA Tigre",
      "url": "img/teams/CA Tigre.svg"
  },
  "Cambuur Leeuwarden": {
      "name": "Cambuur Leeuwarden",
      "url": "img/teams/Cambuur Leeuwarden.svg"
  },
  "SC Cambuur": {
      "name": "SC Cambuur",
      "url": "img/teams/Cambuur Leeuwarden.svg"
  },
  "Carrick Rangers": {
      "name": "Carrick Rangers",
      "url": "img/teams/Carrick Rangers.svg"
  }, 
  "Caykur Rizespor": {
      "name": "Caykur Rizespor",
      "url": "img/teams/Caykur Rizespor.svg"
  },
  "Central Coast Mariners": {
      "name": "Central Coast Mariners",
      "url": "img/teams/Central Coast Mariners.svg"
  },
  "Central Cordoba SdE": {
      "name": "Central Cordoba SdE",
      "url": "img/teams/Central Cordoba SdE.svg"
  },
  "CA Central Cordoba SE": {
      "name": "CA Central Cordoba SE",
      "url": "img/teams/Central Cordoba SdE.svg"
  },//ndryshime
  "CFR Cluj": {
      "name": "CFR Cluj",
      "url": "img/teams/CFR Cluj.svg"
  },
  "FC CFR 1907 Cluj": {
      "name": "FC CFR 1907 Cluj",
      "url": "img/teams/CFR Cluj.svg"
  }, //ndryshime
  "Chivas Guadalajara": {
      "name": "Chivas Guadalajara",
      "url": "img/teams/Chivas Guadalajara.svg"
  },
  "CD Guadalajara": {
      "name": "CD Guadalajara",
      "url": "img/teams/Chivas Guadalajara.svg"
  },//ndryshime
  "Cliftonville": {
      "name": "Cliftonville",
      "url": "img/teams/Cliftonville.svg"
  },
  "Cliftonville FC": {
      "name": "Cliftonville FC",
      "url": "img/teams/Cliftonville.svg"
  },//ndryshime
  "Club America": {
      "name": "Club America",
      "url": "img/teams/Club America.svg"
  },
  "Coleraine": {
      "name": "Coleraine",
      "url": "img/teams/Coleraine.svg"
  },
  "Coleraine FC": {
      "name": "Coleraine FC",
      "url": "img/teams/Coleraine.svg"
  },//ndryshime
  "Crusaders": {
      "name": "Crusaders",
      "url": "img/teams/Crusaders.svg"
  },
  "Crusaders FC": {
      "name": "Crusaders FC",
      "url": "img/teams/Crusaders.svg"
  },//ndryshime
  "Cruz Azul": {
      "name": "Cruz Azul",
      "url": "img/teams/Cruz Azul.svg"
  },
  "CS U Craiova": {
      "name": "CS U Craiova",
      "url": "img/teams/CS U Craiova.svg"
  },
  "CS Universitatea Craiova": {
      "name": "CS Universitatea Craiova",
      "url": "img/teams/CS U Craiova.svg"
  },//ndryshime
  "CSM Politehnica Iasi": {
      "name": "CSM Politehnica Iasi",
      "url": "img/teams/CSM Politehnica Iasi.svg"
  },
  "CSM Politehnica lasi": {
      "name": "CSM Politehnica lasi",
      "url": "img/teams/CSM Politehnica Iasi.svg"
  },//ndryshime
  "De Graafschap": {
      "name": "De Graafschap",
      "url": "img/teams/De Graafschap.svg"
  },
  "Defensa y Justicia": {
      "name": "Defensa y Justicia",
      "url": "img/teams/Defensa y Justicia.svg"
  },
  "Deportivo Riestra": {
      "name": "Deportivo Riestra",
      "url": "img/teams/Deportivo Riestra.svg"
  },
  "Deportivo Riestra AFBC": {
      "name": "Deportivo Riestra AFBC",
      "url": "img/teams/Deportivo Riestra.svg"
  },//ndryshime
  "Dinamo Bucharest": {
      "name": "Dinamo Bucharest",
      "url": "img/teams/Dinamo Bucharest.svg"
  },
  "Dukla Banska Bystric": {
      "name": "Dukla Banska Bystric",
      "url": "img/teams/Dukla Banska Bystric.svg"
  },
  "Mfk Dukla Banska Bystric": {
      "name": "Mfk Dukla Banska Bystric",
      "url": "img/teams/Dukla Banska Bystric.svg"
  },//ndryshime
  "Dunajska Streda": {
      "name": "Dunajska Streda",
      "url": "img/teams/Dunajska Streda.svg"
  },
  "DAC 1904 Dunajska Streda": {
      "name": "DAC 1904 Dunajska Streda",
      "url": "img/teams/Dunajska Streda.svg"
  },//ndryshime
  "Dungannon Swifts": {
      "name": "Dungannon Swifts",
      "url": "img/teams/Dungannon Swifts.svg"
  },
  "Estudiantes LP": {
      "name": "Estudiantes LP",
      "url": "img/teams/Estudiantes LP.svg"
  },
  "Estudiantes de La Plata": {
      "name": "Estudiantes de La Plata",
      "url": "img/teams/Estudiantes LP.svg"
  },//ndryshime
  "Etoile Carouge": {
      "name": "Etoile Carouge",
      "url": "img/teams/Etoile Carouge.svg"
  },
  "Etoile Carouge FC": {
      "name": "Etoile Carouge FC",
      "url": "img/teams/Etoile Carouge.svg"
  },//ndryshime
  "Excelsior": {
      "name": "Excelsior",
      "url": "img/teams/Excelsior.svg"
  },
  "Excelsior Rotterdam": {
      "name": "Excelsior Rotterdam",
      "url": "img/teams/Excelsior.svg"
  },//ndryshime
  "Eyupspor": {
      "name": "Eyupspor",
      "url": "img/teams/Eyupspor.svg"
  },
  "Farul Constanta": {
      "name": "Farul Constanta",
      "url": "img/teams/Farul Constanta.svg"
  },
  "FC Farul Constanta": {
      "name": "FC Farul Constanta",
      "url": "img/teams/Farul Constanta.svg"
  },//ndryshime
  "FC Botosani": {
      "name": "FC Botosani",
      "url": "img/teams/FC Botosani.svg"
  },
  "FC Den Bosch": {
      "name": "FC Den Bosch",
      "url": "img/teams/FC Den Bosch.svg"
  },
  "FC Dordrecht": {
      "name": "FC Dordrecht",
      "url": "img/teams/FC Dordrecht.svg"
  },
  "FC Eindhoven": {
      "name": "FC Eindhoven",
      "url": "img/teams/FC Eindhoven.svg"
  },
  "FC Emmen": {
      "name": "FC Emmen",
      "url": "img/teams/FC Emmen.svg"
  },
  "FC Groningen": {
      "name": "FC Groningen",
      "url": "img/teams/FC Groningen.svg"
  },
  "FC Koper": {
      "name": "FC Koper",
      "url": "img/teams/FC Koper.svg"
  },
  "FC Kosice": {
      "name": "FC Kosice",
      "url": "img/teams/FC Kosice.svg"
  },
  "FC Schaffhausen": {
      "name": "FC Schaffhausen",
      "url": "img/teams/FC Schaffhausen.svg"
  },
  "FC Thun": {
      "name": "FC Thun",
      "url": "img/teams/FC Thun.svg"
  },
  "FC Twente": {
      "name": "FC Twente",
      "url": "img/teams/FC Twente.svg"
  },
  "FC Twente Enschede": {
      "name": "FC Twente Enschede",
      "url": "img/teams/FC Twente.svg"
  },//ndryshime
  "FC Unirea 2004 Slobozia": {
      "name": "FC Unirea 2004 Slobozia",
      "url": "img/teams/FC Unirea 2004 Slobozia.svg"
  },
  "FC Utrecht Reserves": {
      "name": "FC Utrecht Reserves",
      "url": "img/teams/FC Utrecht Reserves.svg"
  },
  "FC Utrecht": {
      "name": "FC Utrecht",
      "url": "img/teams/FC Utrecht.svg"
  },
  "FC Vaduz": {
      "name": "FC Vaduz",
      "url": "img/teams/FC Vaduz.svg"
  },
  "FC Volendam": {
      "name": "FC Volendam",
      "url": "img/teams/FC Volendam.svg"
  },
  "FCSB": {
      "name": "FCSB",
      "url": "img/teams/FCSB.svg"
  },
  "Fotbal Club FCSB": {
      "name": "Fotbal Club FCSB",
      "url": "img/teams/FCSB.svg"
  },//ndryshime
  "Fenerbache": {
      "name": "Fenerbache",
      "url": "img/teams/Fenerbache.svg"
  },
  "Fenerbahce Istanbul": {
      "name": "Fenerbahce Istanbul",
      "url": "img/teams/Fenerbache.svg"
  },//ndryshime
  "Feyenoord": {
      "name": "Feyenoord",
      "url": "img/teams/Feyenoord.svg"
  },
  "Feyenoord Rooterdam": {
      "name": "Feyenoord Rooterdam",
      "url": "img/teams/Feyenoord.svg"
  },//ndryshime
  "FK Zeleziarne Podbrezova": {
      "name": "FK Zeleziarne Podbrezova",
      "url": "img/teams/FK Zeleziarne Podbrezova.svg"
  },
  "Fortuna Sittard": {
      "name": "Fortuna Sittard",
      "url": "img/teams/Fortuna Sittard.svg"
  },
  "Galatasaray": {
      "name": "Galatasaray",
      "url": "img/teams/Galatasaray.svg"
  },
  "Galatasaray Istanbul": {
      "name": "Galatasaray Istanbul",
      "url": "img/teams/Galatasaray.svg"
  },//ndryshime
  "Gaziantep FK": {
      "name": "Gaziantep FK",
      "url": "img/teams/Gaziantep FK.svg"
  },
  "Gimnasia LP": {
      "name": "Gimnasia LP",
      "url": "img/teams/Gimnasia LP.svg"
  },
  "Gimnasia y Esgrima La Plata": {
      "name": "Gimnasia y Esgrima La Plata",
      "url": "img/teams/Gimnasia LP.svg"
  },//ndryshime
  "Glenavon": {
      "name": "Glenavon",
      "url": "img/teams/Glenavon.svg"
  },
  "Glenavon FC": {
      "name": "Glenavon FC",
      "url": "img/teams/Glenavon.svg"
  },//ndryshime
  "Glentoran": {
      "name": "Glentoran",
      "url": "img/teams/Glentoran.svg"
  },
  "Glentoran FC": {
      "name": "Glentoran FC",
      "url": "img/teams/Glentoran.svg"
  },//ndryshime
  "Gloria Buzau": {
      "name": "Gloria Buzau",
      "url": "img/teams/Gloria Buzau.svg"
  },
  "FC Gloria Buzau": {
      "name": "FC Gloria Buzau",
      "url": "img/teams/Gloria Buzau.svg"
  },//ndryshime
  "Go Ahead Eagles": {
      "name": "Go Ahead Eagles",
      "url": "img/teams/Go Ahead Eagles.svg"
  },
  "Godoy Cruz": {
      "name": "Godoy Cruz",
      "url": "img/teams/Godoy Cruz.svg"
  },
  "CD Godoy Cruz": {
      "name": "CD Godoy Cruz",
      "url": "img/teams/Godoy Cruz.svg"
  },//ndryshime
  "Goztepe": {
      "name": "Goztepe",
      "url": "img/teams/Goztepe.svg"
  },
  "Goztepe Izmir": {
      "name": "Goztepe Izmir",
      "url": "img/teams/Goztepe.svg"
  },//ndryshime
  "Hatayspor": {
      "name": "Hatayspor",
      "url": "img/teams/Hatayspor.svg"
  },
  "Hatayspor Antakya": {
      "name": "Hatayspor Antakya",
      "url": "img/teams/Hatayspor.svg"
  },//ndryshime
  "Heerenveen": {
      "name": "Heerenveen",
      "url": "img/teams/Heerenveen.svg"
  },
  "SC Heerenveen": {
      "name": "SC Heerenveen",
      "url": "img/teams/Heerenveen.svg"
  },//ndryshime
  "Helmond Sport": {
      "name": "Helmond Sport",
      "url": "img/teams/Helmond Sport.svg"
  },
  "Heracles": {
      "name": "Heracles",
      "url": "img/teams/Heracles.svg"
  },
  "Heracles Almelo": {
      "name": "Heracles Almelo",
      "url": "img/teams/Heracles.svg"
  },//ndryshime
  "Huracan": {
      "name": "Huracan",
      "url": "img/teams/Huracan.svg"
  },
  "CA Huracan": {
      "name": "CA Huracan",
      "url": "img/teams/Huracan.svg"
  },//ndryshime
  "Independiente Rivadavia": {
      "name": "Independiente Rivadavia",
      "url": "img/teams/Independiente Rivadavia.svg"
  },
  "Instituto AC Cordoba": {
      "name": "Instituto AC Cordoba",
      "url": "img/teams/Instituto AC Cordoba.svg"
  },
  "Istanbul Basaksehir": {
      "name": "Istanbul Basaksehir",
      "url": "img/teams/Istanbul Basaksehir.svg"
  },
  "Juarez FC": {
      "name": "Juarez FC",
      "url": "img/teams/Juarez FC.svg"
  },
  "FC Juarez": {
      "name": "FC Juarez",
      "url": "img/teams/Juarez FC.svg"
  },//ndryshime
  "Kasimpasa": {
      "name": "Kasimpasa",
      "url": "img/teams/Kasimpasa.svg"
  },
  "Kasimpasa Istanbul": {
      "name": "Kasimpasa Istanbul",
      "url": "img/teams/Kasimpasa.svg"
  },//ndryshime
  "Kayserispor": {
      "name": "Kayserispor",
      "url": "img/teams/Kayserispor.svg"
  },
  "KFC Komarno": {
      "name": "KFC Komarno",
      "url": "img/teams/KFC Komarno.svg"
  },
  "Konyaspor": {
      "name": "Konyaspor",
      "url": "img/teams/Konyaspor.svg"
  },
  "Lanus": {
      "name": "Lanus",
      "url": "img/teams/Lanus.svg"
  },
  "CA Lanus": {
      "name": "CA Lanus",
      "url": "img/teams/Lanus.svg"
  },//ndryshime
  "Larne": {
      "name": "Larne",
      "url": "img/teams/Larne.svg"
  },
  "Larne FC": {
      "name": "Larne FC",
      "url": "img/teams/Larne.svg"
  },//ndryshime
  "Lechia Gdansk": {
      "name": "Lechia Gdansk",
      "url": "img/teams/NoKit.svg"
  },
  "Lech Poznan": {
      "name": "Lech Poznan",
      "url": "img/teams/NoKit.svg"
  },
  "MFK Ruzomberok": {
      "name": "MFK Ruzomberok",
      "url": "img/teams/MFK Ruzomberok.svg"
  },
  "MFK Skalica": {
      "name": "MFK Skalica",
      "url": "img/teams/MFK Skalica.svg"
  },
  "MFK Zemplin Michalovce": {
      "name": "MFK Zemplin Michalovce",
      "url": "img/teams/MFK Zemplin Michalovce.svg"
  },
  "Monterrey": {
      "name": "Monterrey",
      "url": "img/teams/Monterrey.svg"
  },
  "CF Monterrey": {
      "name": "CF Monterrey",
      "url": "img/teams/Monterrey.svg"
  },//ndryshime
  "MSK Zilina": {
      "name": "MSK Zilina",
      "url": "img/teams/MSK Zilina.svg"
  },
  "NAC": {
      "name": "NAC",
      "url": "img/teams/NAC.svg"
  },
  "NAC Breda": {
      "name": "NAC Breda",
      "url": "img/teams/NAC.svg"
  },//ndryshime
  "ND Primorje": {
      "name": "ND Primorje",
      "url": "img/teams/ND Primorje.svg"
  },
  "NEC": {
      "name": "NEC",
      "url": "img/teams/NEC.svg"
  },
  "NEC Nijmegen": {
      "name": "NEC Nijmegen",
      "url": "img/teams/NEC.svg"
  },//ndryshime
  "Necaxa": {
      "name": "Necaxa",
      "url": "img/teams/Necaxa.svg"
  },
  "Club Necaxa": {
      "name": "Club Necaxa",
      "url": "img/teams/Necaxa.svg"
  },//ndryshime
  "Neuchatel Xamax": {
      "name": "Neuchatel Xamax",
      "url": "img/teams/Neuchatel Xamax.svg"
  },
  "Newcastle Jets": {
      "name": "Newcastle Jets",
      "url": "img/teams/Newcastle Jets.svg"
  },
  "Newell's": {
      "name": "Newell's",
      "url": "img/teams/Newell's.svg"
  },
  "Newell's Old Boys": {
      "name": "Newell's Old Boys",
      "url": "img/teams/Newell's.svg"
  },//ndryshime
  "NK Bravo": {
      "name": "NK Bravo",
      "url": "img/teams/NK Bravo.svg"
  },
  "NK Cejle": {
      "name": "NK Cejle",
      "url": "img/teams/NK Cejle.svg"
  },
  "NK Domzale": {
      "name": "NK Domzale",
      "url": "img/teams/NK Domzale.svg"
  },
  "NK Maribor": {
      "name": "NK Maribor",
      "url": "img/teams/NK Maribor.svg"
  },
  "NK Nafta 1903": {
      "name": "NK Nafta 1903",
      "url": "img/teams/NK Nafta 1903.svg"
  },
  "NK Radomlje": {
      "name": "NK Radomlje",
      "url": "img/teams/NK Radomlje.svg"
  },
  "NS Mura": {
      "name": "NS Mura",
      "url": "img/teams/NS Mura.svg"
  },
  "Olimpija Ljubljana": {
      "name": "Olimpija Ljubljana",
      "url": "img/teams/Olimpija Ljubljana.svg"
  },
  "Otelul Galati": {
      "name": "Otelul Galati",
      "url": "img/teams/Otelul Galati.svg"
  },
  "ASC Otelul Galati": {
      "name": "ASC Otelul Galati",
      "url": "img/teams/Otelul Galati.svg"
  },//ndryshime
  "Pachuca": {
      "name": "Pachuca",
      "url": "img/teams/Pachuca.svg"
  },
  "CF Pachuca": {
      "name": "CF Pachuca",
      "url": "img/teams/Pachuca.svg"
  },//ndryshime
  "PEC Zwolle": {
      "name": "PEC Zwolle",
      "url": "img/teams/PEC Zwolle.svg"
  },
  "Perth Glory": {
      "name": "Perth Glory",
      "url": "img/teams/Perth Glory.svg"
  },
  "Perth Glory FC": {
      "name": "Perth Glory FC",
      "url": "img/teams/Perth Glory.svg"
  },//ndryshime
  "Petrolul Ploiesti": {
      "name": "Petrolul Ploiesti",
      "url": "img/teams/Petrolul Ploiesti.svg"
  },
  "FC Petrolul Ploiesti": {
      "name": "FC Petrolul Ploiesti",
      "url": "img/teams/Petrolul Ploiesti.svg"
  },//ndryshime
  "Portadown": {
      "name": "Portadown",
      "url": "img/teams/Portadown.svg"
  },
  "Portadown FC": {
      "name": "Portadown FC",
      "url": "img/teams/Portadown.svg"
  },//ndryshime
  "PSV Reserves": {
      "name": "PSV Reserves",
      "url": "img/teams/PSV Reserves.svg"
  },
  "PSV": {
      "name": "PSV",
      "url": "img/teams/PSV.svg"
  },
  "Puebla": {
      "name": "Puebla",
      "url": "img/teams/Puebla.svg"
  },
  "Club Puebla": {
      "name": "Club Puebla",
      "url": "img/teams/Puebla.svg"
  },//ndryshime
  "Queretaro": {
      "name": "Queretaro",
      "url": "img/teams/Queretaro.svg"
  },
  "Queretaro FC": {
      "name": "Queretaro FC",
      "url": "img/teams/Queretaro.svg"
  },//ndryshime
  "Racing Club": {
      "name": "Racing Club",
      "url": "img/teams/Racing Club.svg"
  },
  "Racing Club de Ferrol": {
      "name": "Racing Club de Ferrol",
      "url": "img/teams/Racing Club.svg"
  },//ndryshime
  "Rapid Bucuresti": {
      "name": "Rapid Bucuresti",
      "url": "img/teams/Rapid Bucuresti.svg"
  },
  "River Plate": {
      "name": "River Plate",
      "url": "img/teams/River Plate.svg"
  },
  "CA River Plate (ARG)": {
      "name": "CA River Plate (ARG)",
      "url": "img/teams/River Plate.svg"
  },//ndryshime
  "RKC Waalwijk": {
      "name": "RKC Waalwijk",
      "url": "img/teams/RKC Waalwijk.svg"
  },
  "Roda JC": {
      "name": "Roda JC",
      "url": "img/teams/Roda JC.svg"
  },
  "Roda JC Kerkrade": {
      "name": "Roda JC Kerkrade",
      "url": "img/teams/Roda JC.svg"
  },//ndryshime
  "Rosario Central": {
      "name": "Rosario Central",
      "url": "img/teams/Rosario Central.svg"
  },
  "CA Rosario Central": {
      "name": "CA Rosario Central",
      "url": "img/teams/Rosario Central.svg"
  },//ndryshime
  "Samsunspor": {
      "name": "Samsunspor",
      "url": "img/teams/Samsunspor.svg"
  },
  "San Lorenzo": {
      "name": "San Lorenzo",
      "url": "img/teams/San Lorenzo.svg"
  },
  "CA San Lorenzo de Almagro": {
      "name": "CA San Lorenzo de Almagro",
      "url": "img/teams/San Lorenzo.svg"
  },//ndryshime
  "San Martin de San Juan": {
      "name": "San Martin de San Juan",
      "url": "img/teams/San Martin de San Juan.svg"
  },
  "Santos Laguna": {
      "name": "Santos Laguna",
      "url": "img/teams/Santos Laguna.svg"
  },
  "Club Santos Laguna": {
      "name": "Club Santos Laguna",
      "url": "img/teams/Santos Laguna.svg"
  },//ndryshime
  "Sarmiento": {
      "name": "Sarmiento",
      "url": "img/teams/Sarmiento.svg"
  },
  "Ca Sarmiento Junin": {
      "name": "Ca Sarmiento Junin",
      "url": "img/teams/Sarmiento.svg"
  },//ndryshime
  "Sivasspor": {
      "name": "Sivasspor",
      "url": "img/teams/Sivasspor.svg"
  },
  "Slovan Bratislava": {
      "name": "Slovan Bratislava",
      "url": "img/teams/Slovan Bratislava.svg"
  },
  "SK Slovan Bratislava": {
      "name": "SK Slovan Bratislava",
      "url": "img/teams/Slovan Bratislava.svg"
  },//ndryshime
  "Sparta Rotterdam": {
      "name": "Sparta Rotterdam",
      "url": "img/teams/Sparta Rotterdam.svg"
  },
  "Spartak Trnava": {
      "name": "Spartak Trnava",
      "url": "img/teams/Spartak Trnava.svg"
  },
  "FC Spartak Trnava": {
      "name": "FC Spartak Trnava",
      "url": "img/teams/Spartak Trnava.svg"
  },//ndryshime
  "Stade Lausanne-Ouchy": {
      "name": "Stade Lausanne-Ouchy",
      "url": "img/teams/Stade Lausanne-Ouchy.svg"
  },
  "Stade Lausanne Ouchy": {
      "name": "Stade Lausanne Ouchy",
      "url": "img/teams/Stade Lausanne-Ouchy.svg"
  },//ndryshime
  "Stade Nyonnais": {
      "name": "Stade Nyonnais",
      "url": "img/teams/Stade Nyonnais.svg"
  },
  "FC Stade Nyonnais": {
      "name": "FC Stade Nyonnais",
      "url": "img/teams/Stade Nyonnais.svg"
  },//ndryshime
  "Sydney FC": {
      "name": "Sydney FC",
      "url": "img/teams/Sydney FC.svg"
  },
  "Telstar": {
      "name": "Telstar",
      "url": "img/teams/Telstar.svg"
  },
  "SC Telstar": {
      "name": "SC Telstar",
      "url": "img/teams/Telstar.svg"
  },//ndryshime
  "Tigres UANL": {
      "name": "Tigres UANL",
      "url": "img/teams/Tigres UANL.svg"
  },
  "Tijuana": {
      "name": "Tijuana",
      "url": "img/teams/Tijuana.svg"
  },
  "Club Tijuana de Caliente": {
      "name": "Club Tijuana de Caliente",
      "url": "img/teams/Tijuana.svg"
  },//ndryshime
  "Toluca": {
      "name": "Toluca",
      "url": "img/teams/Toluca.svg"
  },
  "Deportivo Toluca FC": {
      "name": "Deportivo Toluca FC",
      "url": "img/teams/Toluca.svg"
  },//ndryshime
  "Top Oss": {
      "name": "Top Oss",
      "url": "img/teams/Top Oss.svg"
  },
  "Trabzonspor": {
      "name": "Trabzonspor",
      "url": "img/teams/Trabzonspor.svg"
  },
  "Unam Pumas": {
      "name": "Unam Pumas",
      "url": "img/teams/Unam Pumas.svg"
  },
  "Pumas UNAM": {
      "name": "Pumas UNAM",
      "url": "img/teams/Unam Pumas.svg"
  },//ndryshime
  "Union Santa Fe": {
      "name": "Union Santa Fe",
      "url": "img/teams/Union Santa Fe.svg"
  },
  "Union de Santa Fe": {
      "name": "Union de Santa Fe",
      "url": "img/teams/Union Santa Fe.svg"
  },//ndryshime
  "Universitatea Cluj": {
      "name": "Universitatea Cluj",
      "url": "img/teams/Universitatea Cluj.svg"
  },
  "FC Universitatea Cluj": {
      "name": "FC Universitatea Cluj",
      "url": "img/teams/Universitatea Cluj.svg"
  },//ndryshime
  "UTA Arad": {
      "name": "UTA Arad",
      "url": "img/teams/UTA Arad.svg"
  },
  "FC UTA Arad": {
      "name": "FC UTA Arad",
      "url": "img/teams/UTA Arad.svg"
  },//ndryshime
  "Velez Sarsfield": {
      "name": "Velez Sarsfield",
      "url": "img/teams/Velez Sarsfield.svg"
  },
  "Vitesse": {
      "name": "Vitesse",
      "url": "img/teams/Vitesse.svg"
  },
  "Vitesse Arnhem": {
      "name": "Vitesse Arnhem",
      "url": "img/teams/Vitesse.svg"
  },//ndryshime
  "VVV": {
      "name": "VVV",
      "url": "img/teams/VVV.svg"
  },
  "VVV Venio": {
      "name": "VVV Venio",
      "url": "img/teams/VVV.svg"
  },//ndryshime
  "Wellington Phoenix": {
      "name": "Wellington Phoenix",
      "url": "img/teams/Wellington Phoenix.svg"
  },
  "Western Sydney Wanderers": {
      "name": "Western Sydney Wanderers",
      "url": "img/teams/Western Sydney Wanderers.svg"
  },
  "Western United FC": {
      "name": "Western United FC",
      "url": "img/teams/Western United FC.svg"
  },
  "Wil 1900": {
      "name": "Wil 1900",
      "url": "img/teams/Wil 1900.svg"
  },
  "FC Wil 1900": {
      "name": "FC Wil 1900",
      "url": "img/teams/Wil 1900.svg"
  },//ndryshime
  "Willem II": {
      "name": "Willem II",
      "url": "img/teams/Willem II.svg"
  },
  "Willem II Tilburg": {
      "name": "Willem II Tilburg",
      "url": "img/teams/Willem II.svg"
  },
  "Sparta Prague B": {
    "name": "Sparta Prague B",
    "url": "img/teams/Sparta Prague B.svg"
  },
  "FC Zlin": {
    "name": "FC Zlin",
    "url": "img/teams/FC Zlin.svg"
  },
  

  "Leon": { "name": "Leon", "url": "img/teams/Leon.svg" },
  "Linfield": { "name": "Linfield", "url": "img/teams/Linfield.svg" },
  "Loughgall": { "name": "Loughgall", "url": "img/teams/Loughgall.svg" },
  "Maastricht": { "name": "Maastricht", "url": "img/teams/Maastricht.svg" },
  "Macarthur FC": { "name": "Macarthur FC", "url": "img/teams/Macarthur FC.svg" },
  "Mazatlan FC": { "name": "Mazatlan FC", "url": "img/teams/Mazatlan FC.svg" },
  "Melbourne City": { "name": "Melbourne City", "url": "img/teams/Melbourne City.svg" },
  "Melbourne Victory": { "name": "Melbourne Victory", "url": "img/teams/Melbourne Victory.svg" },
  // Recognized national teams without a local kit must not borrow a club kit.
  "Azerbaijan": { "name": "Azerbaijan", "url": "img/teams/NoKit.svg" },
  "Lithuania": { "name": "Lithuania", "url": "img/teams/NoKit.svg" },
  "Malta": { "name": "Malta", "url": "img/teams/NoKit.svg" },
  "Kosovo": { "name": "Kosovo", "url": "img/teams/NoKit.svg" },
  "Austria": { "name": "Austria", "url": "img/teams/NoKit.svg" },
  "Wales": { "name": "Wales", "url": "img/teams/NoKit.svg" },
  "Latvia": { "name": "Latvia", "url": "img/teams/NoKit.svg" },
  "Hungary": { "name": "Hungary", "url": "img/teams/NoKit.svg" },
  "Montenegro": { "name": "Montenegro", "url": "img/teams/NoKit.svg" },
  "Armenia": { "name": "Armenia", "url": "img/teams/NoKit.svg" },
  "Bosnia and Herzegovina": { "name": "Bosnia and Herzegovina", "url": "img/teams/NoKit.svg" },
  "Northern Ireland": { "name": "Northern Ireland", "url": "img/teams/NoKit.svg" },
  "Georgia": { "name": "Georgia", "url": "img/teams/NoKit.svg" },
  "Kazakhstan": { "name": "Kazakhstan", "url": "img/teams/NoKit.svg" },
  "Faroe Islands": { "name": "Faroe Islands", "url": "img/teams/NoKit.svg" },
  "Moldova": { "name": "Moldova", "url": "img/teams/NoKit.svg" },
  "Slovakia": { "name": "Slovakia", "url": "img/teams/NoKit.svg" },
  "Slovenia": { "name": "Slovenia", "url": "img/teams/NoKit.svg" },
  "North Macedonia": { "name": "North Macedonia", "url": "img/teams/NoKit.svg" },
  "Ireland": { "name": "Republic of Ireland", "url": "img/teams/repofireland.svg" },
  "Czechia": { "name": "Czech Republic", "url": "img/teams/NoKit.svg" },
  "Turkiye": { "name": "Turkey", "url": "img/teams/turkey.svg" },

}

// Index both provider aliases and display names once, rather than normalizing the
// entire catalogue for every team rendered on the page.
const clubTokens = new Set(['fc', 'afc', 'cf', 'sc', 'ac', 'fk', 'sk', 'bk', 'club']);
const exactKits = new Map();
const simplifiedKits = new Map();
const candidatesByUrl = new Map();
const matchCache = new Map();
const MAX_CACHE_SIZE = 1000;

function normalizeTeamName(name) {
  return name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/æ/g, 'ae')
    .replace(/œ/g, 'oe')
    .replace(/ø/g, 'o')
    .replace(/ł/g, 'l')
    .replace(/[.’'`]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function simplifyTeamName(name) {
  return name.split(' ').filter(token => !clubTokens.has(token)).join(' ');
}

function compactName(name) {
  return name.replace(/ /g, '');
}

function indexName(index, name, url) {
  if (!name) return;
  // Keep collisions ambiguous instead of silently picking the first club.
  if (!index.has(name)) index.set(name, url);
  else if (index.get(name) !== url) index.set(name, null);
}

Object.entries(teamKits).forEach(([alias, kit]) => {
  if (!candidatesByUrl.has(kit.url)) candidatesByUrl.set(kit.url, new Set());
  [alias, kit.name].forEach(name => {
    const normalized = normalizeTeamName(name);
    const simplified = simplifyTeamName(normalized);
    indexName(exactKits, normalized, kit.url);
    indexName(exactKits, compactName(normalized), kit.url);
    indexName(simplifiedKits, simplified, kit.url);
    indexName(simplifiedKits, compactName(simplified), kit.url);
    if (simplified) candidatesByUrl.get(kit.url).add(simplified);
  });
});

const kitCandidates = Array.from(candidatesByUrl, ([url, names]) => ({
  url,
  names: Array.from(names),
}));

function lookupKit(index, name) {
  return index.get(name) || index.get(compactName(name)) || null;
}

// Prefer dedicated women's/youth/reserve kits when available; only fall back to
// the parent team after trying the complete name.
function parentTeamName(name) {
  return name
    .replace(/\b(?:u\s?\d{1,2}|under\s?\d{1,2}|women(?:s)?|ladies|w|reserves?)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Resolve an exact alias first, then rank similar names across all available kits.
 * Unrecognizable names return null so callers can use their generic kit fallback.
 * @param {string} teamName
 * @returns {string|null} Relative image URL, preserving the existing caller API.
 */
function findTeamKit(teamName) {
  if (typeof teamName !== 'string') return null;
  const normalized = normalizeTeamName(teamName);
  if (!normalized) return null;
  if (matchCache.has(normalized)) return matchCache.get(normalized);

  const simplified = simplifyTeamName(normalized);
  const parent = parentTeamName(simplified);
  let result = lookupKit(exactKits, normalized)
    || lookupKit(simplifiedKits, simplified);
  if (!result && parent && parent !== simplified) {
    result = lookupKit(exactKits, parent) || lookupKit(simplifiedKits, parent);
  }

  if (!result && simplified) {
    const searchName = parent || simplified;
    let bestScore = 0;
    let bestUrl = null;
    for (const candidate of kitCandidates) {
      for (const name of candidate.names) {
        const score = calculateSimilarity(searchName, name);
        // Stable tie-breaking favors the first catalogue entry, but every alias
        // competes on its score (no early substring match).
        if (score > bestScore) {
          bestScore = score;
          bestUrl = candidate.url;
        }
      }
    }
    const length = compactName(searchName).length;
    // Very short names need stronger evidence to avoid unrelated team kits.
    const threshold = length <= 3 ? 0.9 : length <= 5 ? 0.75 : 0.65;
    if (bestScore >= threshold) result = bestUrl;
  }

  if (result) result = `${result}?v=2`;

  if (matchCache.size >= MAX_CACHE_SIZE) matchCache.delete(matchCache.keys().next().value);
  matchCache.set(normalized, result);
  return result;
}

function calculateSimilarity(first, second) {
  const firstCompact = compactName(first);
  const secondCompact = compactName(second);
  const direct = stringSimilarity(firstCompact, secondCompact);
  const firstTokens = first.split(' ');
  const secondTokens = second.split(' ');
  const sorted = stringSimilarity(
    firstTokens.slice().sort().join(''),
    secondTokens.slice().sort().join('')
  );
  const shared = new Set(firstTokens.filter(token => secondTokens.includes(token))).size;
  const tokenScore = shared / Math.max(new Set(firstTokens).size, new Set(secondTokens).size);
  // Whole-token containment supports "Inter" -> "Inter Milan", without treating
  // "Inter" as a strong match for "Internacional" or "Winterthur".
  const contained = shared > 0 && shared === Math.min(firstTokens.length, secondTokens.length);
  const containmentScore = contained ? 0.8 + 0.15 * tokenScore : 0;
  return Math.max(direct, sorted * 0.98, 0.7 * tokenScore + 0.3 * direct, containmentScore);
}

function stringSimilarity(first, second) {
  if (first === second) return 1;
  const length = Math.max(first.length, second.length);
  return length ? 1 - editDistance(first, second) / length : 0;
}

// Optimal string alignment distance also handles adjacent typos (Seriba/Serbia).
// Three rolling rows avoid allocating a full matrix for every candidate.
function editDistance(first, second) {
  let previous = Array.from({ length: second.length + 1 }, (_, index) => index);
  let beforePrevious = previous;
  for (let i = 1; i <= first.length; i++) {
    const current = [i];
    for (let j = 1; j <= second.length; j++) {
      current[j] = Math.min(
        previous[j] + 1,
        current[j - 1] + 1,
        previous[j - 1] + (first[i - 1] === second[j - 1] ? 0 : 1)
      );
      if (i > 1 && j > 1 && first[i - 1] === second[j - 2] && first[i - 2] === second[j - 1]) {
        current[j] = Math.min(current[j], beforePrevious[j - 2] + 1);
      }
    }
    beforePrevious = previous;
    previous = current;
  }
  return previous[second.length];
}

export { findTeamKit };
